var _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCohen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-63",
    d: "M79.19,239.25c-94.34,54.47-94.33,142.77,0,197.24s247.29,54.46,341.62,0,94.33-142.77,0-197.24S173.52,184.79,79.19,239.25Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-63",
    d: "M105.78,426.42q-1,2.67-5.71,3.3L48.29,399.48l-5.86-5.93a.45.45,0,0,1,.46-.75l10.79,3.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M404.47,416.27c.65,1.78,2.55,2.89,5.71,3.3L462,389.34l5.86-5.94a.45.45,0,0,0-.46-.75l-10.79,3.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M375.37,304.51l52.74-30.45c1.36-.79,1.36-2.06,0-2.84l-70.65-40.79a5.46,5.46,0,0,0-4.92,0L299.8,260.88c-1.36.78-1.36,2.06,0,2.84l70.65,40.79A5.46,5.46,0,0,0,375.37,304.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M132.2,409.63l58.7-33.89c1.51-.87,1.51-2.28,0-3.16l-78.62-45.39a6.06,6.06,0,0,0-5.47,0l-58.7,33.89c-1.51.87-1.51,2.29,0,3.16l78.62,45.39A6.06,6.06,0,0,0,132.2,409.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M69.22,397.62l59.31,34.29,9.16,1.86a.28.28,0,0,0,.31-.41l-2.87-5.26L75.8,393.8C74,392.76,67.8,396.8,69.22,397.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M441,387.47l-59.32,34.3-9.16,1.86a.28.28,0,0,1-.3-.41l2.87-5.26,59.32-34.3C436.25,382.61,442.45,386.65,441,387.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-63",
    points: "379.19 392.55 483.52 332.31 415.7 293.16 311.38 353.4 379.19 392.55",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--symbols-3--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--exclamation-mark--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.71,244l-3.8-1a1.35,1.35,0,0,1-1-1.48l5.94-27.69a1.14,1.14,0,0,1,1.47-.8l7.19,2a1.11,1.11,0,0,1,.89,1.37l-9.06,27A1.31,1.31,0,0,1,450.71,244Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.23,256.51a4.28,4.28,0,1,1,5.26-3A4.26,4.26,0,0,1,445.23,256.51Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.22,261.77l-2.72-1.7a1.08,1.08,0,0,1-.44-1.39l11.15-20.18a.91.91,0,0,1,1.33-.27l5.14,3.23a.89.89,0,0,1,.36,1.27l-13.41,18.89A1.07,1.07,0,0,1,462.22,261.77Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,270.25a3.48,3.48,0,1,1,4.8-1.09A3.46,3.46,0,0,1,455,270.25Z",
    style: {
      fill: "#1B4ED8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--symbols-2--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--question-mark--inject-63",
    d: "M280.57,83.75a3.68,3.68,0,0,1-1.43,1.86,20.06,20.06,0,0,1-2.45,1.47l-3,1.56a14.75,14.75,0,0,0-3,2.08,13.47,13.47,0,0,0-2.52,3.09,12.73,12.73,0,0,0-1.56,4.52,12.29,12.29,0,0,0,.15,5.15,10.91,10.91,0,0,0,2.16,4.28,12.72,12.72,0,0,0,3.92,3.15,17.87,17.87,0,0,0,5.47,1.8,21.33,21.33,0,0,0,4.28.3,19.7,19.7,0,0,0,3.79-.51,19.46,19.46,0,0,0,3.38-1.14,26,26,0,0,0,3-1.57l-1.68-4a2,2,0,0,0-1.66-1.37,2.29,2.29,0,0,0-1.28.24c-.5.22-1.1.46-1.81.72a13.44,13.44,0,0,1-2.54.59,11.73,11.73,0,0,1-3.49-.13,8.27,8.27,0,0,1-2.5-.83,6,6,0,0,1-1.85-1.45,5.18,5.18,0,0,1-1.12-4.32,6.86,6.86,0,0,1,1.4-3.28,11.4,11.4,0,0,1,2.51-2.23,23.2,23.2,0,0,1,3-1.68,25.47,25.47,0,0,0,2.9-1.58,9,9,0,0,0,2.23-2,4.8,4.8,0,0,0,1-2.84l.37-5.87-6-1Zm11-16.94a5.2,5.2,0,0,0-1.51-1.4,5.55,5.55,0,0,0-2.06-.76,5.45,5.45,0,0,0-2.17,0,5.54,5.54,0,0,0-1.89.83,5.3,5.3,0,0,0-2.21,3.52,5.24,5.24,0,0,0,.08,2.16,5.43,5.43,0,0,0,.86,1.89,5.86,5.86,0,0,0,1.51,1.42,5.37,5.37,0,0,0,2,.78,5.59,5.59,0,0,0,2.2-.07,5.46,5.46,0,0,0,1.88-.85,5,5,0,0,0,1.4-1.51,5.32,5.32,0,0,0,.76-2,5.44,5.44,0,0,0-.05-2.17A5.2,5.2,0,0,0,291.57,66.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--question-mark--inject-63",
    d: "M312.52,130.3a3.94,3.94,0,0,0-1-1.07,3.78,3.78,0,0,0-1.41-.64,3.89,3.89,0,0,0-2.94.47,3.63,3.63,0,0,0-1.06,1,3.91,3.91,0,0,0-.63,1.41,4,4,0,0,0-.06,1.54,4,4,0,0,0,.51,1.37,3.8,3.8,0,0,0,1,1.06,3.88,3.88,0,0,0,1.42.63,3.87,3.87,0,0,0,2.93-.45,3.93,3.93,0,0,0,1.08-1,3.88,3.88,0,0,0,.15-4.33Zm12.6-20.91a8,8,0,0,0-1.35-3.13,9.36,9.36,0,0,0-2.65-2.41,13,13,0,0,0-3.81-1.51,14.51,14.51,0,0,0-3-.4,14,14,0,0,0-2.72.2,13.78,13.78,0,0,0-2.45.66,17.38,17.38,0,0,0-2.18,1l1,2.94a1.41,1.41,0,0,0,1.12,1,1.66,1.66,0,0,0,.92-.12c.37-.13.8-.28,1.32-.43a9.65,9.65,0,0,1,1.83-.31,8.4,8.4,0,0,1,2.47.25,5.86,5.86,0,0,1,1.74.69A4.22,4.22,0,0,1,318.6,109a3.72,3.72,0,0,1,.62,3.12,4.93,4.93,0,0,1-1.14,2.27,8.25,8.25,0,0,1-1.88,1.48A17.27,17.27,0,0,1,314,116.9a17.53,17.53,0,0,0-2.13,1,6.1,6.1,0,0,0-1.67,1.32,3.43,3.43,0,0,0-.82,2l-.51,4.16,4.2,1,1.42-3.5a2.57,2.57,0,0,1,1.09-1.25,14.93,14.93,0,0,1,1.8-.95c.69-.3,1.41-.63,2.18-1a10.67,10.67,0,0,0,2.22-1.34,9.71,9.71,0,0,0,1.92-2.09,9,9,0,0,0,1.31-3.14A8.86,8.86,0,0,0,325.12,109.39Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--symbols-1--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--exclamation-mark--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.8,140.92l-3.61.91a1.27,1.27,0,0,1-1.53-.75l-7.94-25.57a1.08,1.08,0,0,1,.85-1.34l6.84-1.71a1,1,0,0,1,1.36.72l5,26.44A1.24,1.24,0,0,1,138.8,140.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,153.8a4,4,0,1,1,2.95-4.9A4,4,0,0,1,140.09,153.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.38,157.9l-2.72,1.74a1.09,1.09,0,0,1-1.46-.18l-13.61-18.85a.91.91,0,0,1,.33-1.33l5.15-3.3a.91.91,0,0,1,1.32.21l11.45,20.36A1.06,1.06,0,0,1,122.38,157.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,168.14a3.51,3.51,0,1,1,1.06-4.85A3.49,3.49,0,0,1,127,168.14Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.17,59.21h0l-.05,0h0L87.33,56.4h0l-.06,0h0c-5.17-2.62-12.09-1.85-19.53,2.94-15,9.64-26.38,31.85-25.52,49.61.43,8.86,3.84,14.94,9,17.62h0l.05,0h0l4.8,2.79h0l.06,0h0c5.18,2.63,12.1,1.86,19.55-2.93C90.6,116.8,102,94.59,101.16,76.83,100.73,68,97.33,61.89,92.17,59.21Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.17,59.21h0l-.05,0h0L87.33,56.4h0l-.06,0h0c-5.17-2.62-12.09-1.85-19.53,2.94-15,9.64-26.38,31.85-25.52,49.61.43,8.86,3.84,14.94,9,17.62h0l.05,0h0l4.8,2.79h0l.06,0h0c5.18,2.63,12.1,1.86,19.55-2.93C90.6,116.8,102,94.59,101.16,76.83,100.73,68,97.33,61.89,92.17,59.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.66,129.14l-4.41-2.59h0l-.05,0c-5.16-2.68-8.56-8.76-9-17.6C41.82,101,43.88,92.19,47.6,84l4.8,2.78c-3.73,8.18-5.78,17-5.4,24.9C47.42,120.37,50.69,126.37,55.66,129.14Z",
    style: {
      fill: "#1B4ED8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.65,126.44C90.6,116.8,102,94.59,101.16,76.83S87.48,52.46,72.52,62.1,46.14,93.94,47,111.7,60.69,136.07,75.65,126.44Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.65,126.44C90.6,116.8,102,94.59,101.16,76.83S87.48,52.46,72.52,62.1,46.14,93.94,47,111.7,60.69,136.07,75.65,126.44Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.11,125.2c-8.81.42-10.25-9.49-10.46-13.77-.76-15.67,9.74-36.09,22.93-44.58a20.08,20.08,0,0,1,9.47-3.52c8.82-.42,10.26,9.49,10.46,13.77.77,15.67-9.74,36.09-22.93,44.58a20,20,0,0,1-9.47,3.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,97.2a.84.84,0,0,1-.31,0,1,1,0,0,1-.65-.91V73.57a1,1,0,0,1,1.92,0V93.45L87.35,79.87a1,1,0,1,1,1.51,1.18L76.57,96.83A1,1,0,0,1,75.81,97.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4,114l-.13,0a.4.4,0,0,1-.28-.5L75.31,95.5a.41.41,0,0,1,.5-.28.41.41,0,0,1,.28.51l-5.32,17.93A.41.41,0,0,1,70.4,114Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.51,91.71c1.76-1.13,3.27-.36,3.37,1.73a7.26,7.26,0,0,1-3,5.84c-1.76,1.13-3.27.36-3.37-1.73A7.24,7.24,0,0,1,75.51,91.71Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "470.62 94.53 379.55 41.95 379.55 120.07 470.61 172.64 470.62 94.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68,43.9l88.81,51.28v75.51l-88.81-51.27V43.9M379.55,42v78.12l91.06,52.57V94.53L379.55,42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.22 93.03 473.22 171.14 470.61 172.64 470.62 94.53 473.22 93.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.55 41.95 382.15 40.45 473.22 93.03 470.62 94.53 379.55 41.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.55 41.95 382.15 40.45 473.22 93.03 470.62 94.53 379.55 41.95",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "379.55 41.95 382.15 40.45 473.22 93.03 470.62 94.53 379.55 41.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "473.22 93.03 470.62 94.53 470.62 109.55 473.22 108.05 473.22 93.03",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "473.22 93.03 470.62 94.53 470.62 109.55 473.22 108.05 473.22 93.03"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "470.62 109.55 379.55 56.98 379.55 41.95 470.62 94.53 470.62 109.55",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.43,114.4c0,.83-.62,1.14-1.38.7l-6.83-3.94a3,3,0,0,1-1.39-2.3c0-.83.62-1.15,1.39-.71l6.83,3.95A3,3,0,0,1,464.43,114.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.92,107.75c0,.83-.62,1.14-1.39.7l-6.83-3.94a3,3,0,0,1-1.38-2.3c0-.83.62-1.15,1.38-.71l6.83,3.94A3,3,0,0,1,452.92,107.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.4,101.1c0,.83-.62,1.14-1.39.7l-6.83-3.94a3,3,0,0,1-1.38-2.3c0-.83.62-1.15,1.38-.71L440,98.79A3,3,0,0,1,441.4,101.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.88,94.45c0,.83-.62,1.14-1.38.7l-6.83-3.94a3,3,0,0,1-1.39-2.3c0-.83.62-1.15,1.39-.71l6.82,3.94A3,3,0,0,1,429.88,94.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,87.8c0,.83-.62,1.14-1.38.7l-6.83-3.94a3,3,0,0,1-1.39-2.3c0-.83.62-1.15,1.39-.71L417,85.49A3,3,0,0,1,418.36,87.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.85,81.15c0,.83-.62,1.14-1.39.7l-6.83-3.94a3,3,0,0,1-1.39-2.3c0-.83.63-1.15,1.39-.71l6.83,3.94A3,3,0,0,1,406.85,81.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.33,74.5c0,.83-.62,1.14-1.39.7l-6.83-3.94A3,3,0,0,1,385.73,69c0-.82.62-1.14,1.38-.7l6.83,3.94A3,3,0,0,1,395.33,74.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.84 122.29 455.46 117.47 455.46 125.02 463.84 129.96 463.84 122.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.84 132.9 455.46 128.07 455.46 135.62 463.84 140.57 463.84 132.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.84 143.5 455.46 138.68 455.46 146.23 463.84 151.17 463.84 143.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.84 154.1 455.46 149.28 455.46 156.83 463.84 161.78 463.84 154.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.31 115.64 443.93 110.82 443.93 118.36 452.31 123.31 452.31 115.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.31 126.24 443.93 121.42 443.93 128.97 452.31 133.91 452.31 126.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.31 136.84 443.93 132.02 443.93 139.57 452.31 144.52 452.31 136.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.31 147.45 443.93 142.63 443.93 150.18 452.31 155.12 452.31 147.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.79 108.98 432.41 104.16 432.41 111.71 440.79 116.65 440.79 108.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.79 119.59 432.41 114.77 432.41 122.31 440.79 127.26 440.79 119.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.79 130.19 432.41 125.37 432.41 132.92 440.79 137.86 440.79 130.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.79 140.79 432.41 135.97 432.41 143.52 440.79 148.47 440.79 140.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.26 102.33 420.88 97.51 420.88 105.06 429.26 110 429.26 102.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.26 112.93 420.88 108.11 420.88 115.66 429.26 120.6 429.26 112.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.26 123.53 420.88 118.72 420.88 126.26 429.26 131.21 429.26 123.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.26 134.14 420.88 129.32 420.88 136.87 429.26 141.81 429.26 134.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.73 95.67 409.35 90.85 409.35 98.4 417.73 103.34 417.73 95.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.73 106.28 409.35 101.46 409.35 109 417.73 113.95 417.73 106.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.73 116.88 409.35 112.06 409.35 119.61 417.73 124.55 417.73 116.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.73 127.48 409.35 122.66 409.35 130.21 417.73 135.16 417.73 127.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.21 89.02 397.83 84.2 397.83 91.75 406.21 96.69 406.21 89.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.21 99.62 397.83 94.8 397.83 102.35 406.21 107.29 406.21 99.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.21 110.23 397.83 105.41 397.83 112.95 406.21 117.9 406.21 110.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.21 120.83 397.83 116.01 397.83 123.56 406.21 128.5 406.21 120.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.68 82.36 386.3 77.54 386.3 85.09 394.68 90.03 394.68 82.36",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.68 92.97 386.3 88.15 386.3 95.7 394.68 100.64 394.68 92.97",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.68 103.57 386.3 98.75 386.3 106.3 394.68 111.24 394.68 103.57",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.68 114.18 386.3 109.36 386.3 116.9 394.68 121.85 394.68 114.18",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.52,74.84l-.66,1.38a.16.16,0,0,1-.21.09l-1.46-.56c-.23-.09-.32.24-.15.55l1,2a.61.61,0,0,1,.08.38l-.25,1.8c0,.28.21.66.41.63l1.31-.16a.33.33,0,0,1,.26.15l1.31,1.67c.21.27.45.17.41-.16l-.25-2.08a.3.3,0,0,1,.08-.29l1.06-.76c.17-.12.07-.55-.16-.73l-1.46-1.13a.65.65,0,0,1-.21-.33L387,75.13C386.92,74.79,386.62,74.62,386.52,74.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.14,136.5a3,3,0,0,1,1.79-2.89c1.54-.55,2.83.67,3.78,1.7.25.27-.2.4-.4.21-1-.93-2.81-1.87-3.88-.62s-.5,3.08,0,4.43c.9,2.25,3.19,4.61,5.79,4.23,5.41-.8.23-10.51-3.86-11.08-.27,0-.47-.57-.1-.53a6.35,6.35,0,0,1,4.19,2.46A12.45,12.45,0,0,1,453,138.7c1.14,3-.54,6.78-4.26,5.59A8.07,8.07,0,0,1,443.14,136.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.3,134.75a9.18,9.18,0,0,1,1.25-1.46c.17-.19.59,0,.49.29-.25.58-.75.9-1.06,1.42l-.17.26a8.53,8.53,0,0,1,2.95-1,10.3,10.3,0,0,1,6,.55c.19.07.12.25-.05.27a2.2,2.2,0,0,1-.87-.16,11.94,11.94,0,0,0-3.16-.22,10,10,0,0,0-4.43,1.14,2.88,2.88,0,0,1,2.81.69c.08.08.09.26-.07.27a17.35,17.35,0,0,1-1.89-.14,7.62,7.62,0,0,0-2.27.39c-.28.11-.5-.2-.49-.45A4.38,4.38,0,0,1,454.3,134.75Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.94,123.15a26.41,26.41,0,0,0-1.6-2.45l-1.34-2,.11-.05,1.54-.61c.26-.1.53-.2.79-.32a1,1,0,0,0,.51-.35.2.2,0,0,0-.12-.28,3.71,3.71,0,0,0-1.53.46l-1.56.61-.08,0a50.32,50.32,0,0,0-3.41-5c-.13-.15-.24,0-.19.17a18.66,18.66,0,0,0,1.38,2.52c.51.86,1,1.7,1.57,2.54l-2.5,1c-.36.14,0,.67.29.55l2.54-1c.42.67.85,1.34,1.28,2a24.44,24.44,0,0,0,1.67,2.48C416.52,123.69,417.16,123.57,416.94,123.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.49,129.76a25.72,25.72,0,0,0-1.6-2.45l-1.34-2,.12,0,1.53-.62c.26-.1.53-.2.79-.32a.9.9,0,0,0,.52-.35c.05-.09,0-.27-.13-.28a3.78,3.78,0,0,0-1.52.46l-1.57.61-.07,0a52.19,52.19,0,0,0-3.42-5c-.12-.14-.23,0-.18.17A18.22,18.22,0,0,0,423,122.5c.51.85,1,1.69,1.57,2.53l-2.5,1c-.36.15,0,.67.3.56.85-.33,1.69-.68,2.53-1,.43.67.85,1.34,1.28,2a26.22,26.22,0,0,0,1.67,2.48C428.07,130.3,428.71,130.19,428.49,129.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.83,136.41a27.66,27.66,0,0,0-1.6-2.44l-1.34-2,.11,0,1.54-.61.79-.32a1,1,0,0,0,.51-.35c.06-.1,0-.28-.12-.29a4,4,0,0,0-1.53.46l-1.56.61-.08,0a51.06,51.06,0,0,0-3.42-5c-.12-.14-.23,0-.18.17a18.19,18.19,0,0,0,1.38,2.53c.51.85,1,1.7,1.57,2.54-.84.32-1.67.64-2.5,1-.36.14,0,.67.29.55l2.54-1c.42.67.84,1.33,1.28,2a24.3,24.3,0,0,0,1.67,2.47C439.41,137,440.05,136.84,439.83,136.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.44,116.43a26.41,26.41,0,0,0-1.6-2.45c-.44-.68-.89-1.35-1.34-2l.11,0,1.54-.61.79-.32a1,1,0,0,0,.51-.35c.06-.09,0-.28-.12-.28a3.85,3.85,0,0,0-1.53.45l-1.56.61-.08,0a51.38,51.38,0,0,0-3.41-5c-.13-.15-.24,0-.19.16a18.19,18.19,0,0,0,1.38,2.53c.51.86,1,1.7,1.57,2.54-.83.32-1.67.64-2.5,1-.36.14,0,.67.29.55l2.54-1c.42.67.85,1.34,1.28,2a24.3,24.3,0,0,0,1.67,2.47C405,117,405.66,116.85,405.44,116.43Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.94,112.34a27.66,27.66,0,0,0-1.6-2.44c-.44-.68-.89-1.35-1.34-2l.11,0,1.54-.61.79-.32a1,1,0,0,0,.51-.36.2.2,0,0,0-.12-.28,4,4,0,0,0-1.53.46l-1.56.61-.08,0a51.53,51.53,0,0,0-3.41-5c-.13-.14-.24.05-.19.17a18.78,18.78,0,0,0,1.38,2.53c.51.85,1,1.69,1.57,2.54l-2.5,1c-.36.15,0,.68.29.56l2.54-1c.42.67.85,1.33,1.28,2a23.37,23.37,0,0,0,1.67,2.48C416.52,112.88,417.16,112.77,416.94,112.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.49,119a25.58,25.58,0,0,0-1.6-2.44c-.44-.68-.89-1.35-1.34-2l.12,0,1.53-.61.79-.32a1,1,0,0,0,.52-.35c.05-.1,0-.28-.13-.29a3.94,3.94,0,0,0-1.52.46l-1.57.61-.07,0a54.85,54.85,0,0,0-3.42-5c-.12-.14-.23.05-.18.17a17.15,17.15,0,0,0,1.37,2.53c.51.85,1,1.7,1.57,2.54-.83.32-1.67.64-2.5,1-.36.14,0,.67.3.55l2.53-1,1.28,2a26.07,26.07,0,0,0,1.67,2.47C428.07,119.49,428.71,119.38,428.49,119Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.83,125.61a27.81,27.81,0,0,0-1.6-2.45l-1.34-2,.11,0,1.54-.62c.26-.1.53-.2.79-.32a.91.91,0,0,0,.51-.35.2.2,0,0,0-.12-.28,3.82,3.82,0,0,0-1.53.46l-1.56.61-.08,0a48.75,48.75,0,0,0-3.42-5c-.12-.15-.23,0-.18.17a19.41,19.41,0,0,0,1.38,2.53c.51.85,1,1.69,1.57,2.53l-2.5,1c-.36.14,0,.67.29.56.85-.33,1.69-.68,2.54-1,.42.67.84,1.34,1.28,2a24.44,24.44,0,0,0,1.67,2.48C439.41,126.15,440.05,126,439.83,125.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.44,105.62a27.81,27.81,0,0,0-1.6-2.45l-1.34-2,.11,0,1.54-.62c.26-.1.53-.2.79-.32a.91.91,0,0,0,.51-.35.2.2,0,0,0-.12-.28,4,4,0,0,0-1.53.46l-1.56.61-.08,0a50.32,50.32,0,0,0-3.41-5c-.13-.14-.24,0-.19.17a19.41,19.41,0,0,0,1.38,2.53c.51.85,1,1.69,1.57,2.53l-2.5,1c-.36.15,0,.67.29.56l2.54-1,1.28,2a24.44,24.44,0,0,0,1.67,2.48C405,106.16,405.66,106.05,405.44,105.62Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.94,101.76a27.81,27.81,0,0,0-1.6-2.45l-1.34-2,.11,0,1.54-.62.79-.31A1,1,0,0,0,417,96a.2.2,0,0,0-.12-.28,4,4,0,0,0-1.53.46l-1.56.61-.08,0a50.32,50.32,0,0,0-3.41-5c-.13-.14-.24,0-.19.17a19.41,19.41,0,0,0,1.38,2.53c.51.85,1,1.69,1.57,2.54l-2.5,1c-.36.15,0,.67.29.56l2.54-1,1.28,2a24.44,24.44,0,0,0,1.67,2.48C416.52,102.3,417.16,102.19,416.94,101.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.49,108.37a25.58,25.58,0,0,0-1.6-2.44c-.44-.68-.89-1.35-1.34-2l.12,0,1.53-.61.79-.32a1,1,0,0,0,.52-.36c.05-.09,0-.27-.13-.28a3.94,3.94,0,0,0-1.52.46l-1.57.61-.07,0a53.49,53.49,0,0,0-3.42-5c-.12-.14-.23,0-.18.17a17.67,17.67,0,0,0,1.37,2.53c.51.85,1,1.69,1.57,2.54l-2.5,1c-.36.15,0,.68.3.56l2.53-1,1.28,2a25,25,0,0,0,1.67,2.48C428.07,108.91,428.71,108.8,428.49,108.37Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.83,115a26.41,26.41,0,0,0-1.6-2.45l-1.34-2,.11,0,1.54-.61.79-.32a1,1,0,0,0,.51-.35c.06-.09,0-.28-.12-.28a3.67,3.67,0,0,0-1.53.46l-1.56.61-.08,0a48.75,48.75,0,0,0-3.42-5c-.12-.15-.23,0-.18.17a18.66,18.66,0,0,0,1.38,2.52c.51.86,1,1.7,1.57,2.54l-2.5,1c-.36.14,0,.67.29.55l2.54-1c.42.67.84,1.34,1.28,2a24.44,24.44,0,0,0,1.67,2.48C439.41,115.57,440.05,115.45,439.83,115Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.56,132.55a25.72,25.72,0,0,0-1.6-2.45l-1.34-2,.12,0,1.53-.62c.26-.1.53-.2.79-.32a1,1,0,0,0,.51-.35.19.19,0,0,0-.12-.28,3.87,3.87,0,0,0-1.53.46l-1.56.61-.08,0a50.32,50.32,0,0,0-3.41-5c-.13-.15-.24,0-.19.17a19.41,19.41,0,0,0,1.38,2.53c.51.85,1,1.69,1.57,2.53l-2.5,1c-.36.14,0,.67.3.56l2.53-1c.42.67.85,1.34,1.28,2a26.22,26.22,0,0,0,1.67,2.48C451.14,133.09,451.78,133,451.56,132.55Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.56,122a24.51,24.51,0,0,0-1.6-2.45l-1.34-2,.12,0,1.53-.61.79-.32a1,1,0,0,0,.51-.35c.06-.09,0-.28-.12-.28a3.71,3.71,0,0,0-1.53.46l-1.56.61-.08,0a50.32,50.32,0,0,0-3.41-5c-.13-.15-.24,0-.19.17a18.66,18.66,0,0,0,1.38,2.52c.51.86,1,1.7,1.57,2.54l-2.5,1c-.36.14,0,.67.3.55l2.53-1c.42.67.85,1.34,1.28,2a26.22,26.22,0,0,0,1.67,2.48C451.14,122.5,451.78,122.39,451.56,122Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.44,95a26.41,26.41,0,0,0-1.6-2.45l-1.34-2,.11,0,1.54-.61c.26-.1.53-.2.79-.32a1,1,0,0,0,.51-.35.2.2,0,0,0-.12-.28,3.71,3.71,0,0,0-1.53.46l-1.56.61-.08,0a50.32,50.32,0,0,0-3.41-5c-.13-.15-.24,0-.19.17a18.66,18.66,0,0,0,1.38,2.52c.51.86,1,1.7,1.57,2.54l-2.5,1c-.36.14,0,.67.29.55l2.54-1c.42.67.85,1.34,1.28,2a24.44,24.44,0,0,0,1.67,2.48C405,95.58,405.66,95.46,405.44,95Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.46,273.2l-1.87-1,1.7-.4A1.28,1.28,0,0,1,420.46,273.2Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.46,273.2l-1.87-1,1.7-.4A1.28,1.28,0,0,1,420.46,273.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.91,298.16a4.24,4.24,0,0,0,3.8,0l42.7-24.66-63.92-36.31-1.49-.86-42.7,24a1.16,1.16,0,0,0,0,2.2Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,252.18l14.89,8.57,9.64-5.56,11.22,6.47v7.49c0,1-1.1,2.37-1.5,2.14a10.94,10.94,0,0,0-2.14.76,16.48,16.48,0,0,0-3.1,2.29l-34.22-19.15Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,252.18l14.89,8.57,9.64-5.56,11.22,6.47v7.49c0,1-1.1,2.37-1.5,2.14a10.94,10.94,0,0,0-2.14.76,16.48,16.48,0,0,0-3.1,2.29l-34.22-19.15Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.53,262.57v8.12l.14-.08a3.73,3.73,0,0,1,1.82-.57,1.87,1.87,0,0,1,1.2.28v-9.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.44,273.48a2.54,2.54,0,0,1,.54-1.39,4.86,4.86,0,0,1,.52-.6l.18-.17.24-.2.19-.15.42-.28V262.6l-2.08,1.21v9.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.69,269.15c0,1-1.1,2.37-1.5,2.14h0l-1.5-1v-6.17l1.5-2.59.82-.29.68.39Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,287.81v9.27a2.62,2.62,0,0,0,1.27-.3l4.68-2.7,35.68-20.6v-9.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.36,253v7a2.83,2.83,0,0,0,1.27,2.2l55.24,31.89,4.67,2.7a2.62,2.62,0,0,0,1.27.3v-8.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.49,225.15l63.92,36.91v.85c0,.48.67.65,1.49.18s1.49-1.07,1.49-1.89l.09-.81-65.14-37.6-.26-.16a.86.86,0,0,0-.11.4v.39C355,223.9,354.31,224.66,353.49,225.15Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.49,225.15l63.92,36.91v.85c0,.48.67.65,1.49.18s1.49-1.07,1.49-1.89l.09-.81-65.14-37.6-.26-.16a.86.86,0,0,0-.11.4v.39C355,223.9,354.31,224.66,353.49,225.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,286.71l41.76-24.11c.53-.28,1-.5,1.22-.39l-.28-.15-63.92-36.91-.75-.44a2.44,2.44,0,0,0-2,.3L309.3,248.94a1.16,1.16,0,0,0,0,2.19l61.61,35.58A4.17,4.17,0,0,0,374.71,286.71Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08,222.63l.26.16,65.14,37.6a.45.45,0,0,1,.13-.18l.22-.12.47-.27.58-.34a.59.59,0,0,1,.74.07.13.13,0,0,1,.07.06,1.11,1.11,0,0,1,.2.27,1.56,1.56,0,0,1,.17.37c.05.13.09.28.13.42s.07.32.1.5a1.53,1.53,0,0,1,0,.3,1.79,1.79,0,0,1,0,.24,5.44,5.44,0,0,1,0,.57v-1.83a3.91,3.91,0,0,0-1.91-2.93L359.84,222a3.83,3.83,0,0,0-3.38-.25l-.78.46h0a3,3,0,0,1-.33.19h0A.74.74,0,0,0,355.08,222.63Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,298.16l2.58-1.5L416,274.34a2.47,2.47,0,0,1,.53-1.38,5.66,5.66,0,0,1,1.69-1.49,3.84,3.84,0,0,1,1.82-.57,1.92,1.92,0,0,1,1.2.4,6.68,6.68,0,0,0,.71-3.2h1.47c0,2-.67,4-1.49,4.51l-.74.44c-.42.24-.75.25-.75,0v-.39c0-.44-.66-.42-1.49.06s-1.49,1.21-1.49,1.65v.4c0,.22-.57.73-1.26,1.13l-37.39,21.59-4.05,2.34h0a3.92,3.92,0,0,1-1.9.45v-1.69A3.9,3.9,0,0,0,374.71,298.16Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,298.16l2.58-1.5L416,274.34a2.47,2.47,0,0,1,.53-1.38,5.66,5.66,0,0,1,1.69-1.49,3.84,3.84,0,0,1,1.82-.57,1.92,1.92,0,0,1,1.2.4,6.68,6.68,0,0,0,.71-3.2h1.47c0,2-.67,4-1.49,4.51l-.74.44c-.42.24-.75.25-.75,0v-.39c0-.44-.66-.42-1.49.06s-1.49,1.21-1.49,1.65v.4c0,.22-.57.73-1.26,1.13l-37.39,21.59-4.05,2.34h0a3.92,3.92,0,0,1-1.9.45v-1.69A3.9,3.9,0,0,0,374.71,298.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.7,286.72h0l2.58-1.49L407,268.08l9.48-5.47c.67-.4,1.22-.54,1.26-.33,0,0,0,0,0,0v.43c0,.48.66.48,1.48,0a2,2,0,0,0,1.17-1.49v-.47a.71.71,0,0,1,.22-.56l.22-.12.47-.27.58-.34a.59.59,0,0,1,.74.07.13.13,0,0,1,.07.06.86.86,0,0,1,.14.18l.06.09a1.56,1.56,0,0,1,.17.37c.05.13.09.28.13.42s.07.32.1.5a1.53,1.53,0,0,1,0,.3,1.79,1.79,0,0,1,0,.24,5.44,5.44,0,0,1,0,.57v5.82H421.9v-5.82c0-.15,0-.3,0-.45l0-.37a0,0,0,0,0,0,0,4.2,4.2,0,0,1-2.21,2.75,3.64,3.64,0,0,1-1.78.56,1.94,1.94,0,0,1-1.31-.49l-.14.08-.25.15-37.39,21.59-4.05,2.33h0l0,0a4.06,4.06,0,0,1-1.87.43v-1.69A3.91,3.91,0,0,0,374.7,286.72Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.7,286.72h0l2.58-1.49L407,268.08l9.48-5.47c.67-.4,1.22-.54,1.26-.33,0,0,0,0,0,0v.43c0,.48.66.48,1.48,0a2,2,0,0,0,1.17-1.49v-.47a.71.71,0,0,1,.22-.56l.22-.12.47-.27.58-.34a.59.59,0,0,1,.74.07.13.13,0,0,1,.07.06.86.86,0,0,1,.14.18l.06.09a1.56,1.56,0,0,1,.17.37c.05.13.09.28.13.42s.07.32.1.5a1.53,1.53,0,0,1,0,.3,1.79,1.79,0,0,1,0,.24,5.44,5.44,0,0,1,0,.57v5.82H421.9v-5.82c0-.15,0-.3,0-.45l0-.37a0,0,0,0,0,0,0,4.2,4.2,0,0,1-2.21,2.75,3.64,3.64,0,0,1-1.78.56,1.94,1.94,0,0,1-1.31-.49l-.14.08-.25.15-37.39,21.59-4.05,2.33h0l0,0a4.06,4.06,0,0,1-1.87.43v-1.69A3.91,3.91,0,0,0,374.7,286.72Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,250v1.73a1.31,1.31,0,0,0,.76,1.08h0l57.57,33.24,4,2.33h0a4,4,0,0,0,1.9.45v-1.69a3.79,3.79,0,0,1-1.9-.46l-2.57-1.48h0l-59-34.1A1.29,1.29,0,0,1,308.51,250Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,250v1.73a1.31,1.31,0,0,0,.76,1.08h0l57.57,33.24,4,2.33h0a4,4,0,0,0,1.9.45v-1.69a3.79,3.79,0,0,1-1.9-.46l-2.57-1.48h0l-59-34.1A1.29,1.29,0,0,1,308.51,250Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,261.46v1.72a1.31,1.31,0,0,0,.76,1.08h0l57.57,33.24,4,2.34h0a3.92,3.92,0,0,0,1.9.45v-1.69a3.9,3.9,0,0,1-1.9-.45l-2.57-1.49h0l-59-34.09A1.32,1.32,0,0,1,308.51,261.46Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,261.46v1.72a1.31,1.31,0,0,0,.76,1.08h0l57.57,33.24,4,2.34h0a3.92,3.92,0,0,0,1.9.45v-1.69a3.9,3.9,0,0,1-1.9-.45l-2.57-1.49h0l-59-34.09A1.32,1.32,0,0,1,308.51,261.46Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "420.48 254.46 370.55 282.9 304.15 244.79 354.07 216.35 420.48 254.46",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.48 254.46 370.55 282.9 304.15 244.79 354.07 216.35 420.48 254.46",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.09,281.16l48.51-27.78c-1-2.87-.94-6.23.2-10.06l-48.25,27.55S369.81,273.29,370.09,281.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52,267.72a8.22,8.22,0,0,0-3.72,6.42v7.49c0,2.36,1.67,3.32,3.72,2.14l48-27.46v-1.85l-47.44,27c-1.24.71-2.23.14-2.23-1.28l0-6.94a4.9,4.9,0,0,1,2.24-3.85l47.39-27v-2.1Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52,267.72a8.22,8.22,0,0,0-3.72,6.42v7.49c0,2.36,1.67,3.32,3.72,2.14l48-27.46v-1.85l-47.44,27c-1.24.71-2.23.14-2.23-1.28l0-6.94a4.9,4.9,0,0,1,2.24-3.85l47.39-27v-2.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.47,240.27l-66.4-38.1-47.94,27.45A8.17,8.17,0,0,0,302.4,236v7.5a2.61,2.61,0,0,0,1.09,2.39L369.89,284a2.61,2.61,0,0,1-1.09-2.4v-7.49a8.18,8.18,0,0,1,3.72-6.42Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.47,240.27l-66.4-38.1-47.94,27.45A8.17,8.17,0,0,0,302.4,236v7.5a2.61,2.61,0,0,0,1.09,2.39L369.89,284a2.61,2.61,0,0,1-1.09-2.4v-7.49a8.18,8.18,0,0,1,3.72-6.42Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.89,270.49a7.47,7.47,0,0,0-1.09,3.65v7.49a2.61,2.61,0,0,0,1.09,2.4l-66.4-38.11a2.61,2.61,0,0,1-1.09-2.39V236a7.61,7.61,0,0,1,1.09-3.65Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.89,270.49a7.47,7.47,0,0,0-1.09,3.65v7.49a2.61,2.61,0,0,0,1.09,2.4l-66.4-38.11a2.61,2.61,0,0,1-1.09-2.39V236a7.61,7.61,0,0,1,1.09-3.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.25,237.35c-1.21,5.25-1.19,9.78,0,13.63l3.08,1.78c-1.19-3.85-1.21-8.38,0-13.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35,262.82c-1.21,5.24-1.19,9.77,0,13.62l3.08,1.78c-1.19-3.85-1.2-8.38,0-13.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "414.66 237.92 370.91 262.62 303.71 224.07 347.46 199.35 414.66 237.92",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.66 237.92 370.91 262.62 303.71 224.07 347.46 199.35 414.66 237.92",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.43,260.82l42.28-24c-1-3-1-3.89.22-7.86l-42,23.78S370.14,252.66,370.43,260.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,249.46a8.47,8.47,0,0,0-3.87,6.65v5.2c0,2.45,1.73,3.44,3.87,2.22l41.7-23.69v-1.92l-41.17,23.24c-1.28.73-2.32.14-2.31-1.33l0-4.63a5.08,5.08,0,0,1,2.32-4L414.66,228v-2.18Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,249.46a8.47,8.47,0,0,0-3.87,6.65v5.2c0,2.45,1.73,3.44,3.87,2.22l41.7-23.69v-1.92l-41.17,23.24c-1.28.73-2.32.14-2.31-1.33l0-4.63a5.08,5.08,0,0,1,2.32-4L414.66,228v-2.18Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.66,225.78l-67.2-38.56-41.69,23.69a8.46,8.46,0,0,0-3.87,6.65v5.19a2.71,2.71,0,0,0,1.13,2.49l67.2,38.56a2.71,2.71,0,0,1-1.13-2.49v-5.2a8.47,8.47,0,0,1,3.86-6.65Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.66,225.78l-67.2-38.56-41.69,23.69a8.46,8.46,0,0,0-3.87,6.65v5.19a2.71,2.71,0,0,0,1.13,2.49l67.2,38.56a2.71,2.71,0,0,1-1.13-2.49v-5.2a8.47,8.47,0,0,1,3.86-6.65Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.22,252.33a7.79,7.79,0,0,0-1.13,3.78v5.2a2.71,2.71,0,0,0,1.13,2.49L303,225.24a2.71,2.71,0,0,1-1.13-2.49v-5.19a7.93,7.93,0,0,1,1.13-3.79Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.22,252.33a7.79,7.79,0,0,0-1.13,3.78v5.2a2.71,2.71,0,0,0,1.13,2.49L303,225.24a2.71,2.71,0,0,1-1.13-2.49v-5.19a7.93,7.93,0,0,1,1.13-3.79Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.11,218.93c-1.25,5.43-1.23,7.56,0,11.55l3.2,1.84c-1.24-4-1.25-6.11,0-11.55Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.18,244.25c-1.25,5.44-1.23,7.5,0,11.48l3.2,1.85c-1.23-4-1.25-6,0-11.48Z",
    style: {
      fill: "#1B4ED8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "422.52 226.27 378.77 250.97 311.57 212.42 355.32 187.71 422.52 226.27",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.52 226.27 378.77 250.97 311.57 212.42 355.32 187.71 422.52 226.27",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,249.17l42.28-24c-1.05-3-1-4.32.22-8.28l-42,23.77S378,241,378.29,249.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,237.38A8.52,8.52,0,0,0,377,244v5.62c0,2.45,1.73,3.44,3.87,2.22l41.7-23.69v-1.92l-41.17,23.24c-1.28.73-2.31.14-2.31-1.33l0-5.06a5.1,5.1,0,0,1,2.32-4l41.13-23.25V213.7Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,237.38A8.52,8.52,0,0,0,377,244v5.62c0,2.45,1.73,3.44,3.87,2.22l41.7-23.69v-1.92l-41.17,23.24c-1.28.73-2.31.14-2.31-1.33l0-5.06a5.1,5.1,0,0,1,2.32-4l41.13-23.25V213.7Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.52,213.7l-67.2-38.56-41.69,23.69a8.46,8.46,0,0,0-3.87,6.65v5.62a2.7,2.7,0,0,0,1.14,2.49l67.19,38.56a2.71,2.71,0,0,1-1.13-2.49V244a8.5,8.5,0,0,1,3.86-6.65Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.08,240.25A7.79,7.79,0,0,0,377,244v5.63a2.71,2.71,0,0,0,1.13,2.49L310.9,213.59a2.7,2.7,0,0,1-1.14-2.49v-5.62a7.84,7.84,0,0,1,1.14-3.79Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.08,240.25A7.79,7.79,0,0,0,377,244v5.63a2.71,2.71,0,0,0,1.13,2.49L310.9,213.59a2.7,2.7,0,0,1-1.14-2.49v-5.62a7.84,7.84,0,0,1,1.14-3.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,206.85c-1.25,5.44-1.23,8,0,12l3.2,1.85c-1.23-4-1.25-6.55,0-12Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,232.2c-1.25,5.44-1.23,7.91,0,11.89l3.2,1.85c-1.23-4-1.25-6.47,0-11.9Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320,206.85c-1.25,5.44-1.23,8,0,12l3.2,1.85c-1.23-4-1.25-6.55,0-12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,232.2c-1.25,5.44-1.23,7.91,0,11.89l3.2,1.85c-1.23-4-1.25-6.47,0-11.9Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413,211.41l-1.87-1,1.71-.41A1.3,1.3,0,0,1,413,211.41Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,211.41l-1.87-1,1.71-.41A1.3,1.3,0,0,1,413,211.41Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.47,236.36a4.19,4.19,0,0,0,3.81,0L410,211.71l-63.92-36.32-1.5-.86-42.7,24.06a1.16,1.16,0,0,0,0,2.19Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.51,190.38,394.4,199l9.64-5.57,11.21,6.48v7.48c0,1-1.09,2.38-1.49,2.15a11.13,11.13,0,0,0-2.15.76,16.19,16.19,0,0,0-3.09,2.29L374.3,193.39Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.51,190.38,394.4,199l9.64-5.57,11.21,6.48v7.48c0,1-1.09,2.38-1.49,2.15a11.13,11.13,0,0,0-2.15.76,16.19,16.19,0,0,0-3.09,2.29L374.3,193.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,200.77v8.12l.13-.08a3.92,3.92,0,0,1,1.83-.57,1.93,1.93,0,0,1,1.2.28V199Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,211.68a2.47,2.47,0,0,1,.53-1.38,5.15,5.15,0,0,1,.53-.61l.18-.17.23-.19.2-.15c.14-.1.28-.2.42-.28v-8.09L407,202v9.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25,207.35c0,1-1.09,2.38-1.49,2.15h0l-1.5-1v-6.17l1.5-2.58.82-.29.67.39Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.38,226v9.27a2.45,2.45,0,0,0,1.26-.3l4.69-2.7L407,211.68V202Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.93,191.2v7a2.8,2.8,0,0,0,1.27,2.19l55.23,31.89,4.68,2.7a2.46,2.46,0,0,0,1.27.3v-8.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.06,163.35,410,200.26v.86c0,.47.67.65,1.49.17s1.49-1.07,1.49-1.89l.08-.81L347.91,161l-.26-.15a.79.79,0,0,0-.11.39v.4C347.54,162.1,346.88,162.87,346.06,163.35Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.06,163.35,410,200.26v.86c0,.47.67.65,1.49.17s1.49-1.07,1.49-1.89l.08-.81L347.91,161l-.26-.15a.79.79,0,0,0-.11.39v.4C347.54,162.1,346.88,162.87,346.06,163.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.28,224.92,409,200.81c.54-.28,1-.5,1.22-.4l-.27-.15-63.92-36.91-.75-.43a2.37,2.37,0,0,0-2,.3l-41.44,23.92a1.16,1.16,0,0,0,0,2.2l61.61,35.58A4.26,4.26,0,0,0,367.28,224.92Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.65,160.84l.26.15L413,198.59a.49.49,0,0,1,.14-.18l.22-.12.47-.27.58-.34a.6.6,0,0,1,.74.07s.05,0,.07.06a1.55,1.55,0,0,1,.2.28,3,3,0,0,1,.17.36,4.38,4.38,0,0,1,.13.43l.09.49c0,.1,0,.2,0,.3s0,.16,0,.25a5.24,5.24,0,0,1,0,.57v-1.83a3.9,3.9,0,0,0-1.9-2.93l-61.62-35.58a3.81,3.81,0,0,0-3.39-.24l-.77.45,0,0-.33.19h0A.62.62,0,0,0,347.65,160.84Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.28,236.36l2.58-1.49,38.66-22.33a2.48,2.48,0,0,1,.52-1.38,5.54,5.54,0,0,1,1.7-1.48,3.73,3.73,0,0,1,1.82-.58,1.92,1.92,0,0,1,1.2.4,6.64,6.64,0,0,0,.71-3.2h1.46c0,2-.66,4-1.48,4.52l-.74.43c-.42.24-.75.26-.75,0v-.4c0-.44-.67-.41-1.49.06S410,212.16,410,212.6V213c0,.23-.57.73-1.27,1.14l-37.38,21.58-4.05,2.34h0a4,4,0,0,1-1.89.44v-1.69A3.84,3.84,0,0,0,367.28,236.36Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.28,236.36l2.58-1.49,38.66-22.33a2.48,2.48,0,0,1,.52-1.38,5.54,5.54,0,0,1,1.7-1.48,3.73,3.73,0,0,1,1.82-.58,1.92,1.92,0,0,1,1.2.4,6.64,6.64,0,0,0,.71-3.2h1.46c0,2-.66,4-1.48,4.52l-.74.43c-.42.24-.75.26-.75,0v-.4c0-.44-.67-.41-1.49.06S410,212.16,410,212.6V213c0,.23-.57.73-1.27,1.14l-37.38,21.58-4.05,2.34h0a4,4,0,0,1-1.89.44v-1.69A3.84,3.84,0,0,0,367.28,236.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.26,224.92h0l2.58-1.5,29.7-17.14,9.48-5.47c.67-.4,1.22-.54,1.26-.33v.45c0,.48.67.48,1.49,0a2,2,0,0,0,1.17-1.49V199a.71.71,0,0,1,.22-.56l.22-.12.47-.27.58-.34a.6.6,0,0,1,.74.07s.05,0,.07.06a1.18,1.18,0,0,1,.13.18.86.86,0,0,1,.07.1,3,3,0,0,1,.17.36,4.38,4.38,0,0,1,.13.43l.09.49c0,.1,0,.2,0,.3s0,.16,0,.25a5.24,5.24,0,0,1,0,.57v5.81h-1.46v-5.81c0-.16,0-.31,0-.46l0-.36s0,0,0,0a4.2,4.2,0,0,1-2.21,2.75,3.64,3.64,0,0,1-1.79.56,2,2,0,0,1-1.31-.48l-.13.07-.26.15-37.38,21.59-4.05,2.34h0l0,0a4,4,0,0,1-1.86.43v-1.69A3.9,3.9,0,0,0,367.26,224.92Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.26,224.92h0l2.58-1.5,29.7-17.14,9.48-5.47c.67-.4,1.22-.54,1.26-.33v.45c0,.48.67.48,1.49,0a2,2,0,0,0,1.17-1.49V199a.71.71,0,0,1,.22-.56l.22-.12.47-.27.58-.34a.6.6,0,0,1,.74.07s.05,0,.07.06a1.18,1.18,0,0,1,.13.18.86.86,0,0,1,.07.1,3,3,0,0,1,.17.36,4.38,4.38,0,0,1,.13.43l.09.49c0,.1,0,.2,0,.3s0,.16,0,.25a5.24,5.24,0,0,1,0,.57v5.81h-1.46v-5.81c0-.16,0-.31,0-.46l0-.36s0,0,0,0a4.2,4.2,0,0,1-2.21,2.75,3.64,3.64,0,0,1-1.79.56,2,2,0,0,1-1.31-.48l-.13.07-.26.15-37.38,21.59-4.05,2.34h0l0,0a4,4,0,0,1-1.86.43v-1.69A3.9,3.9,0,0,0,367.26,224.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,188.22v1.72a1.32,1.32,0,0,0,.75,1.08l0,0,57.57,33.23,4,2.34h0a4,4,0,0,0,1.9.44v-1.69a4,4,0,0,1-1.91-.45l-2.57-1.49h0l-59-34.09A1.3,1.3,0,0,1,301.08,188.22Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,188.22v1.72a1.32,1.32,0,0,0,.75,1.08l0,0,57.57,33.23,4,2.34h0a4,4,0,0,0,1.9.44v-1.69a4,4,0,0,1-1.91-.45l-2.57-1.49h0l-59-34.09A1.3,1.3,0,0,1,301.08,188.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,199.66v1.72a1.31,1.31,0,0,0,.75,1.08l0,0,57.57,33.23,4,2.34h0a4,4,0,0,0,1.9.44v-1.69a3.85,3.85,0,0,1-1.91-.45l-2.57-1.49h0l-59-34.09A1.28,1.28,0,0,1,301.08,199.66Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,199.66v1.72a1.31,1.31,0,0,0,.75,1.08l0,0,57.57,33.23,4,2.34h0a4,4,0,0,0,1.9.44v-1.69a3.85,3.85,0,0,1-1.91-.45l-2.57-1.49h0l-59-34.09A1.28,1.28,0,0,1,301.08,199.66Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "422.99 197.25 373.06 225.69 306.66 187.58 356.59 159.14 422.99 197.25",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.99 197.25 373.06 225.69 306.66 187.58 356.59 159.14 422.99 197.25",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.61,223.94l48.5-27.77c-1-2.88-.93-6.23.21-10.06l-48.26,27.54S372.33,216.08,372.61,223.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,210.51a8.16,8.16,0,0,0-3.72,6.42v7.49c0,2.36,1.66,3.32,3.72,2.14L423,199.1v-1.85l-47.43,27c-1.24.71-2.24.13-2.24-1.28l0-7a4.91,4.91,0,0,1,2.24-3.85l47.39-27v-2.1Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,210.51a8.16,8.16,0,0,0-3.72,6.42v7.49c0,2.36,1.66,3.32,3.72,2.14L423,199.1v-1.85l-47.43,27c-1.24.71-2.24.13-2.24-1.28l0-7a4.91,4.91,0,0,1,2.24-3.85l47.39-27v-2.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,183.06,356.59,145l-47.95,27.46a8.18,8.18,0,0,0-3.72,6.41v7.49a2.59,2.59,0,0,0,1.09,2.4l66.4,38.11a2.59,2.59,0,0,1-1.09-2.4v-7.5a8.17,8.17,0,0,1,3.73-6.41Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,183.06,356.59,145l-47.95,27.46a8.18,8.18,0,0,0-3.72,6.41v7.49a2.59,2.59,0,0,0,1.09,2.4l66.4,38.11a2.59,2.59,0,0,1-1.09-2.4v-7.5a8.17,8.17,0,0,1,3.73-6.41Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.4,213.27a7.61,7.61,0,0,0-1.09,3.65v7.5a2.59,2.59,0,0,0,1.09,2.4L306,188.71a2.59,2.59,0,0,1-1.09-2.4v-7.49a7.58,7.58,0,0,1,1.09-3.65Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.4,213.27a7.61,7.61,0,0,0-1.09,3.65v7.5a2.59,2.59,0,0,0,1.09,2.4L306,188.71a2.59,2.59,0,0,1-1.09-2.4v-7.49a7.58,7.58,0,0,1,1.09-3.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,180.14c-1.2,5.25-1.19,9.78,0,13.62l3.09,1.78c-1.19-3.84-1.21-8.37,0-13.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,205.6c-1.21,5.25-1.19,9.78,0,13.63L362,221c-1.19-3.85-1.21-8.38,0-13.62Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--open-book--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "379.11 387.71 477.37 330.98 414.59 294.74 316.33 351.47 379.11 387.71",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.11 387.71 477.37 330.98 414.59 294.74 316.33 351.47 379.11 387.71",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.93,358.6v-1.76c0-2.16,3.85-8.34,8.68-11.12l39-22.54v7.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.63,323.18l-39,22.54c-4.83,2.78-8.7,9-8.68,11.12l0,1.76-60.05-34.67h0v-1.76c0-2.16,3.85-8.34,8.67-11.12l39-22.52,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.63,323.18l-39,22.54c-4.83,2.78-8.7,9-8.68,11.12l0,1.76-60.05-34.67h0v-1.76c0-2.16,3.85-8.34,8.67-11.12l39-22.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.92,357l-3.74-2.17L418.26,352a9.72,9.72,0,0,1,6.06.88A5.06,5.06,0,0,1,426.92,357Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.92,357l-3.74-2.17L418.26,352a9.72,9.72,0,0,1,6.06.88A5.06,5.06,0,0,1,426.92,357Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.12 389.35 379.11 387.72 316.32 351.47 316.33 353.1 379.12 389.35",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.12 389.35 379.11 387.72 316.32 351.47 316.33 353.1 379.12 389.35",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.12 389.35 477.38 332.62 477.37 330.98 379.11 387.72 379.12 389.35",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.92,357c0-2.17-4-4-8.8-1.2l-39,22.35v8.09l47.83-27.61S426.94,359.13,426.92,357Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.1 386.21 379.1 378.12 319.05 343.45 319.05 351.54 379.1 386.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.13,355.77l-1.75,1L379.1,378.12l-53-30.62-7-4.05,39-22.35c3.54-2,5.52-1.87,6.91-1.08h0l60.88,35.14C423.66,353.92,421.1,354.18,418.13,355.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.37 372.03 409.6 352.86 411.35 351.86 412.63 352.59 410.88 353.59 377.65 372.77 376.37 372.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.3 370.26 406.53 351.08 408.28 350.08 409.56 350.82 407.81 351.82 374.58 371 373.3 370.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.23 368.49 403.46 349.31 405.21 348.31 406.49 349.05 404.74 350.05 371.51 369.23 370.23 368.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.16 366.71 400.39 347.54 402.14 346.54 403.42 347.28 401.67 348.28 368.44 367.45 367.16 366.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.09 364.94 397.33 345.77 399.07 344.77 400.35 345.51 398.61 346.51 365.37 365.68 364.09 364.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.02 363.17 394.26 344 396.01 343 397.29 343.74 395.54 344.74 362.3 363.91 361.02 363.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.96 361.4 391.19 342.23 392.94 341.23 394.22 341.96 392.47 342.96 359.24 362.14 357.96 361.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.89 359.63 388.12 340.45 389.87 339.45 391.15 340.19 389.4 341.19 356.17 360.37 354.89 359.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.82 357.86 385.05 338.68 386.8 337.68 388.08 338.42 386.33 339.42 353.1 358.6 351.82 357.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.75 356.08 381.98 336.91 383.73 335.91 385.01 336.65 383.26 337.65 350.03 356.82 348.75 356.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.68 354.31 378.91 335.14 380.66 334.14 381.94 334.88 380.19 335.88 346.96 355.05 345.68 354.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.61 352.54 375.84 333.37 377.59 332.37 378.87 333.1 377.12 334.1 343.89 353.28 342.61 352.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.54 350.77 372.77 331.59 374.52 330.59 375.8 331.33 374.05 332.33 340.82 351.51 339.54 350.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.48 349 369.71 329.82 371.46 328.82 372.74 329.56 370.99 330.56 337.75 349.74 336.48 349",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.41 347.23 366.64 328.05 368.39 327.05 369.67 327.79 367.92 328.79 334.69 347.96 333.41 347.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.34 345.45 363.57 326.28 365.32 325.28 366.6 326.02 364.85 327.02 331.62 346.19 330.34 345.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.27 343.68 360.5 324.51 362.25 323.51 363.53 324.25 361.78 325.25 328.55 344.42 327.27 343.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.5,353.67c-.73.07-2.26.56-3.09.75-3.55.8-9.81,3.66-15.81,6.66-8,4-15.55,8.29-15.55,8.29l-54.94-31.68,29-16.59a12.72,12.72,0,0,1,3.58-1.49,8.16,8.16,0,0,1,2.51.86l.38-.67.44.22,60.88,35.14A9.88,9.88,0,0,0,418.5,353.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.06 379.89 385.02 376.86 379.1 380.47 373.15 377.04 379.06 379.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.11 383.93 390.03 377.63 379.11 383.51 366.82 376.84 379.11 383.93",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.05 345.24 328.23 350.78 319.05 346.09 319.05 345.24",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.06 348.4 332.7 356.73 319.05 349.15 319.06 348.4",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.26,352a21,21,0,0,0-2.35.4c-3.54.8-9.8,3.66-15.8,6.66-8,4-15.55,8.29-15.55,8.29l-60.09-34.65s22.86-13.16,31.83-14.9c4.21-.81,6.79-.24,8.36.65h0l59.65,34.44A9.72,9.72,0,0,0,418.26,352Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,348.89a9.72,9.72,0,0,0-6.06-.88,21,21,0,0,0-2.35.4,57.76,57.76,0,0,0-9.81,3.77c-1.95.9-4,1.89-6,2.89-4.82,2.41-9.47,4.92-12.41,6.54l1.36.79c2.94-1.62,7.59-4.13,12.42-6.54,2-1,4-2,6-2.89a57.44,57.44,0,0,1,9.81-3.77,21.27,21.27,0,0,1,2.34-.4,9.7,9.7,0,0,1,6.06.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,347.11a9.82,9.82,0,0,0-6.07-.88c-.72.09-1.5.22-2.34.41a57.25,57.25,0,0,0-9.81,3.76c-1.95.9-4,1.89-6,2.9-4.82,2.41-9.47,4.92-12.42,6.54l1.37.78c2.94-1.61,7.59-4.12,12.41-6.54,2-1,4-2,6-2.89a58.63,58.63,0,0,1,9.81-3.77,21.43,21.43,0,0,1,2.35-.4,9.8,9.8,0,0,1,6.06.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.35,345.34a9.71,9.71,0,0,0-6.06-.88,20.88,20.88,0,0,0-2.34.4,57.13,57.13,0,0,0-9.81,3.77c-2,.9-4,1.89-6,2.89-4.82,2.41-9.47,4.92-12.41,6.54l1.37.79c2.94-1.62,7.59-4.13,12.41-6.54,2-1,4-2,6-2.89a57.76,57.76,0,0,1,9.81-3.77,21.27,21.27,0,0,1,2.34-.4,9.74,9.74,0,0,1,6.07.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.28,343.56a9.75,9.75,0,0,0-6.07-.87,21.27,21.27,0,0,0-2.34.4,57.56,57.56,0,0,0-9.81,3.76c-1.95.9-4,1.89-6,2.9-4.82,2.41-9.47,4.92-12.41,6.54l1.36.78c2.94-1.61,7.59-4.12,12.41-6.54,2-1,4-2,6-2.89a58,58,0,0,1,9.81-3.77,21.27,21.27,0,0,1,2.34-.4,9.78,9.78,0,0,1,6.06.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,341.79a9.71,9.71,0,0,0-6.06-.88,21.27,21.27,0,0,0-2.34.4,57.44,57.44,0,0,0-9.81,3.77c-2,.9-4,1.89-6,2.89-4.82,2.41-9.47,4.93-12.41,6.54l1.37.79c2.94-1.62,7.59-4.13,12.41-6.54,2-1,4-2,6-2.89a57.76,57.76,0,0,1,9.81-3.77,21.27,21.27,0,0,1,2.34-.4,9.74,9.74,0,0,1,6.07.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.13,340a9.73,9.73,0,0,0-6.06-.87,21,21,0,0,0-2.35.4,57.56,57.56,0,0,0-9.81,3.76c-2,.9-4,1.89-6,2.9-4.82,2.41-9.47,4.92-12.41,6.54l1.36.79c2.94-1.62,7.59-4.13,12.42-6.55,2-1,4-2,6-2.89a58.3,58.3,0,0,1,9.81-3.77,21.27,21.27,0,0,1,2.34-.4,9.78,9.78,0,0,1,6.06.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.06,338.24a9.74,9.74,0,0,0-6.07-.88,21.27,21.27,0,0,0-2.34.4,57.44,57.44,0,0,0-9.81,3.77c-1.95.9-4,1.89-6,2.89-4.82,2.42-9.48,4.93-12.42,6.54l1.37.79c2.94-1.62,7.59-4.13,12.41-6.54,2-1,4-2,6-2.89a57.76,57.76,0,0,1,9.81-3.77,21,21,0,0,1,2.35-.4,9.72,9.72,0,0,1,6.06.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,336.46a9.79,9.79,0,0,0-6.06-.87,21.43,21.43,0,0,0-2.35.4,57.2,57.2,0,0,0-9.8,3.76c-2,.9-4,1.89-6,2.9-4.82,2.41-9.47,4.92-12.41,6.54l1.36.79c2.95-1.62,7.6-4.13,12.42-6.55,2-1,4-2,6-2.89a58.3,58.3,0,0,1,9.81-3.77,21.27,21.27,0,0,1,2.34-.4,9.82,9.82,0,0,1,6.07.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.21,334.6a21.43,21.43,0,0,0-2.35.4c-3.54.8-9.8,3.66-15.8,6.66-4.82,2.41-9.47,4.92-12.41,6.54l-1.36-.79c2.94-1.61,7.59-4.12,12.41-6.54,6-3,12.25-5.86,15.8-6.66a21.27,21.27,0,0,1,2.34-.4,9.74,9.74,0,0,1,6.07.88l1.36.79A9.71,9.71,0,0,0,388.21,334.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.13,332.82a19.28,19.28,0,0,0-2.34.41c-3.55.79-9.81,3.65-15.8,6.65-4.82,2.42-9.47,4.93-12.41,6.55l-1.37-.79c2.94-1.62,7.59-4.13,12.41-6.54,6-3,12.26-5.86,15.81-6.66a21.27,21.27,0,0,1,2.34-.4,9.79,9.79,0,0,1,6.06.87l1.37.79A9.82,9.82,0,0,0,385.13,332.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.06,331.05a21.27,21.27,0,0,0-2.34.4c-3.55.8-9.81,3.66-15.81,6.66-4.82,2.41-9.47,4.92-12.41,6.54l-1.36-.79c2.94-1.61,7.59-4.12,12.41-6.54,6-3,12.25-5.86,15.8-6.66a21.27,21.27,0,0,1,2.34-.4,9.82,9.82,0,0,1,6.07.88l1.36.79A9.71,9.71,0,0,0,382.06,331.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,329.27a19.28,19.28,0,0,0-2.34.41c-3.55.79-9.81,3.65-15.8,6.65-4.82,2.42-9.47,4.93-12.41,6.55l-1.37-.79c2.94-1.62,7.59-4.13,12.42-6.54,6-3,12.25-5.86,15.8-6.66a21.27,21.27,0,0,1,2.34-.4,9.71,9.71,0,0,1,6.06.88l1.37.78A9.82,9.82,0,0,0,379,329.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.91,327.5a21.27,21.27,0,0,0-2.34.4c-3.55.8-9.81,3.66-15.8,6.66-4.83,2.41-9.48,4.92-12.42,6.54l-1.36-.79c2.94-1.61,7.59-4.12,12.41-6.54,6-3,12.25-5.86,15.8-6.66a21.43,21.43,0,0,1,2.35-.4,9.8,9.8,0,0,1,6.06.88l1.37.79A9.74,9.74,0,0,0,375.91,327.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.84,325.72a21.6,21.6,0,0,0-2.35.41c-3.55.79-9.8,3.65-15.8,6.66-4.82,2.41-9.47,4.92-12.41,6.54l-1.36-.79c2.94-1.62,7.59-4.13,12.41-6.54,6-3,12.25-5.86,15.8-6.66a21.27,21.27,0,0,1,2.34-.4,9.74,9.74,0,0,1,6.07.88l1.36.78A9.8,9.8,0,0,0,372.84,325.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.76,324a21.27,21.27,0,0,0-2.34.4c-3.55.8-9.81,3.66-15.8,6.66-4.82,2.41-9.47,4.92-12.41,6.54l-1.37-.79c2.94-1.61,7.59-4.12,12.41-6.54,6-3,12.26-5.86,15.81-6.66a20.88,20.88,0,0,1,2.34-.4,9.78,9.78,0,0,1,6.06.88l1.37.79A9.74,9.74,0,0,0,369.76,324Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.69,322.18a19.14,19.14,0,0,0-2.34.4c-3.55.79-9.81,3.65-15.81,6.66-4.82,2.41-9.47,4.92-12.41,6.54l-1.36-.79c2.94-1.62,7.59-4.13,12.41-6.54,6-3,12.25-5.86,15.8-6.66a21.27,21.27,0,0,1,2.34-.4,9.74,9.74,0,0,1,6.07.88l1.36.78A9.72,9.72,0,0,0,366.69,322.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.61,320.4a21.27,21.27,0,0,0-2.34.4c-3.55.8-9.81,3.66-15.8,6.66-4.82,2.41-9.47,4.92-12.41,6.54l-1.37-.79c2.94-1.61,7.59-4.12,12.42-6.54,6-3,12.25-5.86,15.8-6.66a21.27,21.27,0,0,1,2.34-.4,9.78,9.78,0,0,1,6.06.88l1.37.79A9.74,9.74,0,0,0,363.61,320.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,342.48a19.24,19.24,0,0,0-4.86,4.15l-1.25-.72a19.48,19.48,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,342.48a19.24,19.24,0,0,0-4.86,4.15l-1.25-.72a19.48,19.48,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.91,340.7a19.48,19.48,0,0,0-4.86,4.16l-1.25-.72a19.48,19.48,0,0,1,4.86-4.16l35-20.15,1.24.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.84,338.93a19.48,19.48,0,0,0-4.86,4.16l-1.25-.72a19.28,19.28,0,0,1,4.86-4.16l35-20.16,1.24.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.77,337.16a19.28,19.28,0,0,0-4.86,4.16l-1.25-.73a19.44,19.44,0,0,1,4.86-4.15l35-20.16,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.7,335.38a19.48,19.48,0,0,0-4.86,4.16l-1.25-.72a19.48,19.48,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.63,333.61a19.7,19.7,0,0,0-4.87,4.16l-1.24-.72a19.48,19.48,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.56,331.84a19.49,19.49,0,0,0-4.87,4.16l-1.24-.72a19.28,19.28,0,0,1,4.86-4.16l35-20.16,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.48,330.07a19.59,19.59,0,0,0-4.86,4.15l-1.25-.72a19.7,19.7,0,0,1,4.87-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,328.29a19.84,19.84,0,0,0-4.86,4.16l-1.25-.72a19.7,19.7,0,0,1,4.87-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.34,326.52a19.84,19.84,0,0,0-4.86,4.16l-1.25-.72a19.63,19.63,0,0,1,4.86-4.16l35-20.16,1.25.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.27,324.75a19.63,19.63,0,0,0-4.86,4.16l-1.25-.72A19.63,19.63,0,0,1,398,324l35-20.16,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.2,323a19.84,19.84,0,0,0-4.86,4.16l-1.25-.72a19.84,19.84,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.13,321.2a19.84,19.84,0,0,0-4.86,4.16l-1.25-.72a19.84,19.84,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,319.43a19.45,19.45,0,0,0-4.86,4.16l-1.25-.72a19.63,19.63,0,0,1,4.86-4.16l35-20.16,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,317.66a19.45,19.45,0,0,0-4.86,4.16l-1.25-.73a19.84,19.84,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.92,315.88a19.66,19.66,0,0,0-4.86,4.16l-1.25-.72a19.66,19.66,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.85,314.11a19.48,19.48,0,0,0-4.86,4.16l-1.25-.72a19.45,19.45,0,0,1,4.86-4.16l35-20.15,1.25.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.44 330.06 474.63 325.75 474.63 325.08 466.44 330.06",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.63 328.15 460.99 335.78 474.63 327.66 474.63 328.15",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.84,327.51c7.37-3.9,17.25-8.75,22.46-9.76,4.21-.81,6.79-.24,8.36.65h0l59.65,34.44a9.72,9.72,0,0,0-6.06-.88s-29.53-18-48.59-24.16A61.44,61.44,0,0,0,333.84,327.51Z",
    style: {
      opacity: 0.02
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pens--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.12,388.63a1.22,1.22,0,0,1,.27.09l-.52-.29-.09-.05h0l-.1,0,0,0-.09,0-.14,0h-.16a2.22,2.22,0,0,0-1.1.33,5.42,5.42,0,0,0-2.46,4.26,2.37,2.37,0,0,0,.07.61l0,.11s0,0,0,.06a.49.49,0,0,0,0,.11,1.46,1.46,0,0,0,.2.37,1.29,1.29,0,0,0,.36.33l.59.33a1,1,0,0,1-.26-.21,1.9,1.9,0,0,0,1.41-.3A5.41,5.41,0,0,0,75.58,390,1.94,1.94,0,0,0,75.12,388.63Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3,421.6l-3.47,6-.59-.34L72,394.77a1,1,0,0,1-.26-.21,1.92,1.92,0,0,1-.46-1.38,5.41,5.41,0,0,1,2.46-4.25,2.21,2.21,0,0,1,1.1-.34,1.06,1.06,0,0,1,.31,0,1.22,1.22,0,0,1,.27.09l0,0h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.56,421.77c1.36-.78,2.46-.15,2.46,1.42a5.41,5.41,0,0,1-2.46,4.25c-1.36.79-2.46.15-2.46-1.41A5.42,5.42,0,0,1,130.56,421.77Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84,425.42l-.06-.07-3.14-3.45h0l0,0-.05-.06,0,0h0a1.59,1.59,0,0,0-2,0A5.42,5.42,0,0,0,128.1,426a1.58,1.58,0,0,0,1,1.68h0l.18,0h0l4.54,1a1.12,1.12,0,0,0,.79-.18,3.08,3.08,0,0,0,1.41-2.43A1.15,1.15,0,0,0,135.84,425.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,399.74h0l-.08-.05a.7.7,0,0,0-.58.08,1.94,1.94,0,0,0-.87,1.52.68.68,0,0,0,.2.53h0l.1.06,43,24.86,2.45-1.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,424.73l3.47,2,2.45-1.41-4.69-2.71A5.93,5.93,0,0,0,128.32,424.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,427.06h0l-2.84-3.13-.08-.08a1.1,1.1,0,0,0-1.4,0,3.82,3.82,0,0,0-1.74,3,1.15,1.15,0,0,0,.66,1.2h0l.11,0L136,429h0a.59.59,0,0,0,.44-.1,1.74,1.74,0,0,0,.8-1.37A.66.66,0,0,0,137.08,427.06Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,427.06h0l-2.84-3.13-.08-.08a1.1,1.1,0,0,0-1.4,0,3.82,3.82,0,0,0-1.74,3,1.15,1.15,0,0,0,.66,1.2h0l.11,0L136,429h0a.59.59,0,0,0,.44-.1,1.74,1.74,0,0,0,.8-1.37A.66.66,0,0,0,137.08,427.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.24,427.51a1.74,1.74,0,0,1-.8,1.37.59.59,0,0,1-.44.1h0l-2.1-.46c-.33-.07-.55-.38-.55-.89a2.81,2.81,0,0,1,1.26-2.19.8.8,0,0,1,1,0l.06.06,1.41,1.55h0A.61.61,0,0,1,137.24,427.51Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,427.06c.44-.26.8-.05.8.45a1.74,1.74,0,0,1-.8,1.37c-.43.25-.79.05-.79-.46A1.75,1.75,0,0,1,136.44,427.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.69,394.37a.6.6,0,0,0-.61.06,1.93,1.93,0,0,0-.87,1.51.6.6,0,0,0,.26.56h0l9.18,5.31a.68.68,0,0,1-.2-.53,1.94,1.94,0,0,1,.87-1.52.7.7,0,0,1,.58-.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,394.93a1.93,1.93,0,0,1-.87,1.51.63.63,0,0,1-.61.06.6.6,0,0,1-.26-.56,1.93,1.93,0,0,1,.87-1.51.6.6,0,0,1,.61-.06A.61.61,0,0,1,81,394.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,391.21h0l0,0,0,0-3.63-2.09-.08-.05h0a1.59,1.59,0,0,0-1.5.19A4.88,4.88,0,0,0,71.5,393a1.55,1.55,0,0,0,.65,1.43h0l3.67,2.12h0a1.58,1.58,0,0,0,1.54-.17,4.88,4.88,0,0,0,2.21-3.83A1.57,1.57,0,0,0,79,391.21Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,391.21h0l0,0,0,0-3.63-2.09-.08-.05h0a1.59,1.59,0,0,0-1.5.19A4.88,4.88,0,0,0,71.5,393a1.55,1.55,0,0,0,.65,1.43h0l3.67,2.12h0a1.58,1.58,0,0,0,1.54-.17,4.88,4.88,0,0,0,2.21-3.83A1.57,1.57,0,0,0,79,391.21Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4,391.34c1.22-.71,2.21-.14,2.21,1.27a4.88,4.88,0,0,1-2.21,3.83c-1.23.71-2.22.14-2.22-1.27A4.87,4.87,0,0,1,77.4,391.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.24,428.38h0l-1.5-.9h0a.28.28,0,0,0-.3,0,.9.9,0,0,0-.4.7.27.27,0,0,0,.12.26h0l1.49.91h0a.64.64,0,0,0,.28.07.58.58,0,0,0,.58-.58A.57.57,0,0,0,138.24,428.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.33,428.45h0l-.08-.06h0a.29.29,0,0,0-.26,0,.88.88,0,0,0-.41.7.27.27,0,0,0,.12.26l0,0h0a.48.48,0,0,0,.18,0,.58.58,0,0,0,.58-.58A.56.56,0,0,0,138.33,428.45Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.67,379.86a5.45,5.45,0,0,0,2.46,4.26,2,2,0,0,0,1.42.3,1.39,1.39,0,0,1-.27.21l.59-.34a1.14,1.14,0,0,0,.36-.33,1.25,1.25,0,0,0,.2-.36.61.61,0,0,0,.05-.12s0,0,0-.06a.43.43,0,0,0,0-.11,2.32,2.32,0,0,0,.07-.61,5.41,5.41,0,0,0-2.46-4.25,2.18,2.18,0,0,0-1.1-.34h-.16l-.14,0-.08,0h-.06l-.1.05h0l-.09,0-.51.3a.82.82,0,0,1,.26-.1A1.94,1.94,0,0,0,434.67,379.86Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,411.45l3.46,6,.59-.34,56.27-32.51a1.39,1.39,0,0,0,.27-.21A2,2,0,0,0,439,383a5.42,5.42,0,0,0-2.46-4.26,2.19,2.19,0,0,0-1.1-.33,1.55,1.55,0,0,0-.31,0,.82.82,0,0,0-.26.1l-.05,0h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.69,411.63c-1.35-.79-2.45-.15-2.45,1.41a5.44,5.44,0,0,0,2.45,4.26c1.36.78,2.46.15,2.46-1.42A5.41,5.41,0,0,0,379.69,411.63Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.41,415.28l.06-.07,3.14-3.45h0l0,0,.06-.06,0,0h0a1.57,1.57,0,0,1,2,0,5.41,5.41,0,0,1,2.46,4.25,1.6,1.6,0,0,1-.95,1.69h0l-.18,0h-.05l-4.55,1a1.1,1.1,0,0,1-.79-.17,3.11,3.11,0,0,1-1.41-2.43A1.15,1.15,0,0,1,374.41,415.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.26,389.6a0,0,0,0,1,0,0l.09,0a.61.61,0,0,1,.57.08,1.94,1.94,0,0,1,.87,1.51.64.64,0,0,1-.2.53h0l-.11.06-43,24.87L376,415.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.93,414.59l-3.47,2L376,415.17l4.69-2.71A5.91,5.91,0,0,1,381.93,414.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.18,416.92h0l2.85-3.12.07-.09a1.12,1.12,0,0,1,1.4,0,3.83,3.83,0,0,1,1.74,3,1.13,1.13,0,0,1-.66,1.19h0l-.11,0-4.17.91h0a.64.64,0,0,1-.45-.09,1.76,1.76,0,0,1-.79-1.37A.58.58,0,0,1,373.18,416.92Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.18,416.92h0l2.85-3.12.07-.09a1.12,1.12,0,0,1,1.4,0,3.83,3.83,0,0,1,1.74,3,1.13,1.13,0,0,1-.66,1.19h0l-.11,0-4.17.91h0a.64.64,0,0,1-.45-.09,1.76,1.76,0,0,1-.79-1.37A.58.58,0,0,1,373.18,416.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,417.37a1.76,1.76,0,0,0,.79,1.37.65.65,0,0,0,.45.09h0l2.11-.46c.33-.07.54-.38.54-.88a2.78,2.78,0,0,0-1.26-2.19.82.82,0,0,0-1,0l-.06.06-1.41,1.55h0A.58.58,0,0,0,373,417.37Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.81,416.91c-.44-.25-.79-.05-.79.46a1.76,1.76,0,0,0,.79,1.37c.43.25.79,0,.79-.46A1.77,1.77,0,0,0,373.81,416.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,384.22a.64.64,0,0,1,.62.06,1.9,1.9,0,0,1,.86,1.51.61.61,0,0,1-.25.57h0l-9.19,5.3a.64.64,0,0,0,.2-.53,1.94,1.94,0,0,0-.87-1.51.61.61,0,0,0-.57-.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.3,384.79a1.91,1.91,0,0,0,.88,1.5.53.53,0,0,0,.86-.5,1.9,1.9,0,0,0-.86-1.51.64.64,0,0,0-.62-.06A.63.63,0,0,0,429.3,384.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.25,381.07h0l0,0,0,0,3.63-2.09.08-.05h0a1.61,1.61,0,0,1,1.5.18,4.9,4.9,0,0,1,2.21,3.83,1.56,1.56,0,0,1-.65,1.44h0l-3.67,2.12h0a1.58,1.58,0,0,1-1.53-.17,4.9,4.9,0,0,1-2.21-3.83A1.58,1.58,0,0,1,431.25,381.07Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.25,381.07h0l0,0,0,0,3.63-2.09.08-.05h0a1.61,1.61,0,0,1,1.5.18,4.9,4.9,0,0,1,2.21,3.83,1.56,1.56,0,0,1-.65,1.44h0l-3.67,2.12h0a1.58,1.58,0,0,1-1.53-.17,4.9,4.9,0,0,1-2.21-3.83A1.58,1.58,0,0,1,431.25,381.07Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.86,381.19c-1.22-.7-2.21-.13-2.21,1.28a4.9,4.9,0,0,0,2.21,3.83c1.22.7,2.21.13,2.21-1.28A4.9,4.9,0,0,0,432.86,381.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,418.23h0l1.5-.9h0a.32.32,0,0,1,.3,0,.91.91,0,0,1,.4.71.27.27,0,0,1-.12.26h0l-1.49.9h0a.53.53,0,0,1-.28.07.58.58,0,0,1-.31-1.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,418.3h0l.08-.07h0a.3.3,0,0,1,.26,0,.9.9,0,0,1,.4.7.3.3,0,0,1-.11.26h-.06a.41.41,0,0,1-.19,0,.57.57,0,0,1-.57-.58A.53.53,0,0,1,371.93,418.3Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencils--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.27,392.35l-9.6-1.88a.3.3,0,0,0-.28.49l6.51,7.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.39,391a.3.3,0,0,1,.28-.49l1.87.37h0a1.68,1.68,0,0,0-.78,1.53l0,.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42,422.72l-.79-.45-.95-.55L49.9,398.34a4.37,4.37,0,0,1,.27-3.19c.68-1.52,2-2.72,3.1-2.79L94,415.73l1.81,1C94.63,416.16,91.21,422.09,92.42,422.72Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42,421l-1.75-1c-.52-.28-.22-1.55.38-2.86.8-1.75,2.38-3.44,3.07-3.08l1.29.74.46.28c-.69-.37-2.27,1.33-3.07,3.07-.58,1.26-.87,2.49-.43,2.82h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,420.75c-1.21-.63,2.24-6.57,3.44-5.93l1.76,1c-1.2-.63-4.65,5.3-3.45,5.94Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42,422.72l-1.74-1c-1.18-.61,2.09-6.37,3.35-6l.07,0,1.74,1C94.63,416.16,91.21,422.09,92.42,422.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34,390.64l.33-.17,7,3.81L93.37,418.8c.07-.11.12-.12.17,0-1,1.59-1.8,3.61-1.12,4l-.79-.45-.95-.55L49.9,398.34h0L43.39,391A.28.28,0,0,1,43.34,390.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.78,426.93l-7.36-4.21c-.52-.27-.23-1.53.36-2.84.8-1.75,2.37-3.46,3.06-3.11h0l7.38,4.23c1.47.85.12,4-1.52,5.46A1.76,1.76,0,0,1,99.78,426.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,424.64a5.31,5.31,0,0,1,3-3.63,1.2,1.2,0,0,1,1.1.15c1.11,1-.18,3.95-1.73,5.3a1.76,1.76,0,0,1-1.89.48C99.26,426.62,99.05,425.77,99.34,424.64Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457,382.21l9.61-1.88a.3.3,0,0,1,.28.49l-6.52,7.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.87,380.82a.3.3,0,0,0-.28-.49l-1.88.36h0a1.65,1.65,0,0,1,.78,1.54l0,.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.84,412.57l.78-.45.95-.54,40.78-23.39a4.34,4.34,0,0,0-.26-3.18c-.69-1.53-2-2.73-3.1-2.8l-40.76,23.38-1.82,1C415.62,406,419,411.94,417.84,412.57Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.83,410.87l1.75-1c.52-.28.23-1.55-.38-2.87-.8-1.74-2.38-3.44-3.06-3.07l-1.3.74-.45.27c.68-.36,2.26,1.33,3.06,3.08.58,1.26.87,2.49.43,2.82h0A.1.1,0,0,1,420.83,410.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.27,410.61c1.2-.64-2.25-6.57-3.45-5.94l-1.76,1c1.21-.64,4.65,5.3,3.45,5.93Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.84,412.57l1.73-1c1.19-.62-2.09-6.37-3.34-6l-.08,0-1.74,1C415.62,406,419,411.94,417.84,412.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.91,380.49l-.32-.16-7,3.81-42.74,24.51c-.07-.1-.12-.11-.17,0,1,1.6,1.8,3.61,1.13,4l.78-.45.95-.54,40.78-23.39h0l6.52-7.37A.29.29,0,0,0,466.91,380.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.47,416.78l7.37-4.21c.51-.27.23-1.53-.37-2.83-.79-1.76-2.36-3.46-3.06-3.11h0L407,410.86c-1.46.84-.12,4,1.52,5.45A1.73,1.73,0,0,0,410.47,416.78Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.91,414.5a5.27,5.27,0,0,0-3-3.63,1.2,1.2,0,0,0-1.1.14c-1.11,1,.18,3.95,1.73,5.3a1.78,1.78,0,0,0,1.9.49C411,416.47,411.2,415.62,410.91,414.5Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.47,346.87,284,320.55,311.7,336.7l-28.84,36.92s-15.77-.56-18.8-8.1S269.59,349.78,273.47,346.87Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.17,358.71a12.51,12.51,0,0,0-3.06,4c-.86,1.53,0,8.54-.64,11.88s-1.32,4.27-2.54,8.48c-1.35,4.68-4.21,9.08.36,20.43,4.63,11.51,10.82,16.43,15.93,18.88a12.93,12.93,0,0,0,6,.94s6.2-2.95,4.9-6.65S257.17,358.71,257.17,358.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,369.18c-.08,1.22-1.6,3.2-2.2,4.23-2,3.49-2.71,8-3.19,12-2.25,18.75,5.85,27.52-3.5,35.25-2.73,2.05-8.73,2-18.76-8.83-5.12-5.56-8.76-17.54-7.41-23.22s3.52-9.48,4.34-13.83-.45-12.22,1.6-16.06a17.12,17.12,0,0,1,5.35-5.43c1.67-1.21,5.4-2.94,7.11-4.11s2.58-3.51,3.84-2.3l-1.83,3.83c-2.87,4.75-1.91,5.33-1.64,7.7s-.33,5.18-.58,7.69c2.07-3.09,2.8-5.7,5.35-5.46,2.38.22,2.83.09,6.71,3.17S286.36,368.1,286.29,369.18Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,369.18c-.08,1.22-1.6,3.2-2.2,4.23-2,3.49-2.71,8-3.19,12-2.25,18.75,5.85,27.52-3.5,35.25-2.73,2.05-8.73,2-18.76-8.83-5.12-5.56-8.76-17.54-7.41-23.22s3.52-9.48,4.34-13.83-.45-12.22,1.6-16.06a17.12,17.12,0,0,1,5.35-5.43c1.67-1.21,5.4-2.94,7.11-4.11s2.58-3.51,3.84-2.3l-1.83,3.83c-2.87,4.75-1.91,5.33-1.64,7.7s-.33,5.18-.58,7.69c2.07-3.09,2.8-5.7,5.35-5.46,2.38.22,2.83.09,6.71,3.17S286.36,368.1,286.29,369.18Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.64,411.82c-5.12-5.56-8.76-17.54-7.41-23.22a50,50,0,0,1,1.68-5.53c0,.38-.13.77-.15,1.09,0,.73-.09,1.45-.1,2.18,0,2.79.22,5.81,1.61,8.29,1.23,2.21,4.11,7.78,7.23,7.65,1.76-.07,3.1-1.91,3.62-3.93.21-.86.5-3.13.5-3.13a27.42,27.42,0,0,1,8.34,2.63c4.74,2.6,4.63,3.27,4.63,3.27a11.89,11.89,0,0,0,.18,4,9.85,9.85,0,0,0,2,3.8,6.27,6.27,0,0,0,1.22.83c.17,4.26-.67,7.7-4.59,10.94C274.67,422.7,268.67,422.69,258.64,411.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,385.4a62.62,62.62,0,0,0,.06,14.83c-1.3,4.87-2.8,4.85-3.2,2.42s2-12.85,3.75-21.44C281.25,382.63,281.06,384.05,280.9,385.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.24,356.77a10.37,10.37,0,0,1,1.25-6.9c.43-.25.83-.48,1.14-.7,1.85-1.26,2.58-3.51,3.84-2.3l-1.83,3.83c-2.87,4.75-1.91,5.33-1.64,7.7s-.33,5.18-.58,7.69c-1.22,8.16-2.71,11-3,18.61s1.67,12.6.63,13.11-3.26-.16-4.15-6.19.95-16.43,2.44-21.41S267.89,360,267.24,356.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.13,395.79a.73.73,0,0,0,.4.18c5.4.65,8.34,1.75,12.67,6.08a.76.76,0,0,0,1.07,0,.75.75,0,0,0,0-1.07c-4.58-4.57-7.82-5.82-13.56-6.51a.75.75,0,0,0-.84.66A.74.74,0,0,0,265.13,395.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,389.41a.91.91,0,0,0,.4.18c5.59.81,8.77,2.12,13.37,6.68a.77.77,0,0,0,1.1,0,.78.78,0,0,0,0-1.1c-4.85-4.79-8.3-6.24-14.24-7.11a.78.78,0,0,0-.88.66A.79.79,0,0,0,265.56,389.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.86,382.47a.78.78,0,0,0,.43.2c6.18.91,9.88,2.49,14.95,7.51a.86.86,0,0,0,1.21,0,.85.85,0,0,0,0-1.21c-5.33-5.28-9.36-7-15.9-8a.85.85,0,0,0-.68,1.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.38,376.46a.77.77,0,0,0,.42.19c6.05.89,9.64,2.41,14.62,7.34a.86.86,0,0,0,1.19,0,.85.85,0,0,0,0-1.19c-5.23-5.17-9.14-6.86-15.55-7.8a.84.84,0,0,0-.67,1.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08,370.5a.87.87,0,0,0,.42.2c6.05.88,9.64,2.4,14.62,7.33a.84.84,0,1,0,1.18-1.19c-5.23-5.18-9.14-6.87-15.55-7.81a.86.86,0,0,0-1,.71A.85.85,0,0,0,267.08,370.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.6 349.03 293.37 361.92 302.29 367.52 292.11 386.76 263.43 373.03 277.6 349.03",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.43,377.54c6.75,2.66,10.92,5.34,14,9.42s4.07,8.2,1.11,13.14-8.41,10.73-14.87,10.35-10.44-2-16.44-5.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,383.25c-.1,2,8.43,6.06,17.28,10.28,9.5,4.53,11.83,7.48,19.58,11.29,8.86,4.36,12.22,4.61,19.09,2.7s15.35-11.74,9.45-20.79c-4.81-7.37-11-9.4-20.51-11.89a177.52,177.52,0,0,1-22.14-7.15c-6.84-2.65-12.47-7.42-13.88-5.77,1,.48,8.13,4.89,6.77,6.09-.33.62-1.35.42-3.11-.3a3,3,0,0,0-2.45-.12,4.78,4.78,0,0,0-1.77,2.12c-1.09,2-1.23,3.29-2.14,5.43-.53,1.24-.31.52-.8,1.78-.55,1.42-1.61,3.55-1.47,4.85.09.78.65,1,1.26,1.41s1.44.84,2,1.27c.23.18.63.76.5,1.06-.21.49-1.44.26-2,0s-1.37-.42-2-.65S286.06,384,284.5,383.25Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,383.25c-.1,2,8.43,6.06,17.28,10.28,9.5,4.53,11.83,7.48,19.58,11.29,8.86,4.36,12.22,4.61,19.09,2.7s15.35-11.74,9.45-20.79c-4.81-7.37-11-9.4-20.51-11.89a177.52,177.52,0,0,1-22.14-7.15c-6.84-2.65-12.47-7.42-13.88-5.77,1,.48,8.13,4.89,6.77,6.09-.33.62-1.35.42-3.11-.3a3,3,0,0,0-2.45-.12,4.78,4.78,0,0,0-1.77,2.12c-1.09,2-1.23,3.29-2.14,5.43-.53,1.24-.31.52-.8,1.78-.55,1.42-1.61,3.55-1.47,4.85.09.78.65,1,1.26,1.41s1.44.84,2,1.27c.23.18.63.76.5,1.06-.21.49-1.44.26-2,0s-1.37-.42-2-.65S286.06,384,284.5,383.25Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.32,403.36c1.28.64,9.31,4.38,11.84,2.14,2.73-2.43-3.72-6.3-3.72-6.3s-1-6.06,6.34-15c1.26,1,6.55.93,6.48-2.18s-8.93-6.92-9.06-7c9.06,2.43,15,4.51,19.7,11.67,5.9,9-2.57,18.89-9.45,20.79s-10.23,1.66-19.09-2.7C320.48,404.39,319.1,403.82,318.32,403.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,398.6c3.36,1.12,1.06,4.16-3.85,3.17-7.36-1.48-13.47-5.65-21.67-8.24-8.85-4.22-17.87-8.16-17.29-10.39,1.58.59,5,2,5,2,.67.28,2.38.92,2.38.92,6.71,2.9,14.14,7.56,21.4,9.53C319.63,397.32,324,397.48,327.3,398.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,385.37c-3.07-1.78-3.6-3.29-9.62-6.06s-16.19-8.67-22.48-12.34a78,78,0,0,1-6.82-5.05c1-1.18,4.87-.09,8.71,2.33s6.17,4,10,5.94c7.39,4.43,15.81,7.43,20,10.14S335.36,387.14,332.29,385.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.74,384.55a1,1,0,0,1-.17.27c-.07.07-4.87,5.35-5.75,14.86a.89.89,0,0,1-.84.83.74.74,0,0,1-.68-.86c.94-10.17,6-15.69,6.25-16a.71.71,0,0,1,1.08,0A.87.87,0,0,1,332.74,384.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,380.21a1.28,1.28,0,0,1-.15.25A36.48,36.48,0,0,0,319.53,398a.9.9,0,0,1-.87.8.74.74,0,0,1-.65-.88,37.91,37.91,0,0,1,7.57-18.57.72.72,0,0,1,1.08-.07A.87.87,0,0,1,326.79,380.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,397.36a.86.86,0,0,1-.71.54.73.73,0,0,1-.74-.8c.36-10.75,7.28-20.84,7.61-21.19a.71.71,0,0,1,1.08,0,.93.93,0,0,1-.07,1.19c-.07.08-6.77,9.93-7.09,19.94A.85.85,0,0,1,313.68,397.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.18,393.85a.85.85,0,0,1-.7.53.72.72,0,0,1-.75-.78,31.67,31.67,0,0,1,8-20.11.7.7,0,0,1,1.07,0,.93.93,0,0,1-.13,1.2,30.34,30.34,0,0,0-7.43,18.75A1,1,0,0,1,308.18,393.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05,390.83a.85.85,0,0,1-.69.53.71.71,0,0,1-.76-.76c0-11.19,7.91-19.84,8.26-20.19a.71.71,0,0,1,1.08,0,.92.92,0,0,1-.11,1.19c-.08.09-7.66,8.46-7.7,18.84A.92.92,0,0,1,301.05,390.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.16,263s55.87-13.68,80.42-13.52c25.06.16,34.49,18.45,26.95,34.67-10.6,22.77-48.45,69.84-48.45,69.84s-18.65-6.25-23-18.39l8.85-23-30.38,9.68L252.08,318Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,294a213.5,213.5,0,0,0-12.65,21l7.65-2.44c8.63-20.55,10.4-26.54,24.19-36.17C310.16,276.39,300.27,280.11,291,294Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.16,263l-98.58,28.92s2.94,23.6,10.82,38.28c9.93,18.5,25,27,39.46,27.75,13.55.69,28.87-2.51,28.87-2.51s7.79,6.1,15.7,9.24,42.5,17.63,42.5,17.63,9.72-8.22,8.75-25.36L252.08,318Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.93,382.26s1.88-.86,4.57-5.95c-8.95-2.12-38.41-13.65-47.93-17.68-16.94-7.18-22.17-14.76-22.17-14.76s-.11,5,7.33,11.52c0,0,7.79,6.1,15.7,9.24S279.93,382.26,279.93,382.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,322.15s-1.55-1.94-4.94-5.82c-6.14-7-8.76-11.09-22.64-12-13.1-.82-38.82.43-38.82.43s15.1-2.28,34.16-3.59c9.72-.67,17.57.4,23,5.26s14,14.12,14,14.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4,304.34a27.62,27.62,0,0,0,6.5-19.27s3.33,12.67-2,21.88Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.18,116.32s41.34,37.09,48.8,46.32c12.5,15.49,8.67,22.45,5.19,26.35s-13.36,7.86-33.43,14.16C241.62,208.52,231.9,212,231.9,212l-12.89-32,35.19-10.21L232,137.34Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,169.73c4.64,8,7.25,13,15.81,17-12.53-.77-20-15.66-20-15.66Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.92,238.83c15.69-11,13.3-26.21,6.48-36.58A134.47,134.47,0,0,0,219,179.94a196,196,0,0,0-20.15,1c-9.25,1.05-18.48,2.37-27.6,4.28-2.79.58-3.36.59-5.89-.19a15.39,15.39,0,0,0-6.13-.94,17.09,17.09,0,0,0-10.92,5.61c-4.62,5.16-6.39,12.21-7.66,19-3.18,16.95-3.22,28.45-2.8,46.83.23,10,1.56,28.61,4.72,43.37,14,4.29,39.06,2.54,57-1.62,16.21-3.74,34.5-13.62,41.54-29.75,1.14-7.78-6-10.94-7.77-14A21.77,21.77,0,0,1,230.92,238.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.55,244.26s-7.28,9-22.78,6.25-18.47-14.44-18.47-14.44-1,15.07,17.5,18.23C206.05,257.41,211.55,244.26,211.55,244.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.31,114.23c-5.72-6.84-11.42-8.45-14.08-9.07a48.71,48.71,0,0,0-23.87.49,47.86,47.86,0,0,0-5.84,2c-1.39.57-3.66,1.2-4.64,2.4-.73.87-.6,2.38-1.49,3-.7.49-2,.36-2.79.68a15.22,15.22,0,0,0-3.64,2.11,22.87,22.87,0,0,0-5.09,5.3,24.18,24.18,0,0,0-4.22,14.74c.19,3.89,1.26,8.15-.81,11.45-1.06,1.69-2.77,2.82-4.23,4.16a15.19,15.19,0,0,0-5.09,12.79c.62,4.73,4.34,9.07,9,9.8a5.53,5.53,0,0,1-.8-5,11.86,11.86,0,0,0,7.21,6.54c3.41,1.19,6.84.94,10.31.31,7.33-1.34,12.2,1.2,19,4.36a25,25,0,0,0,11.67,2.33c5.57-.45,10.55-2,13.47-4.06a15.77,15.77,0,0,0,6.8-12.92c1.68,1.93,1.69,4.7,1.07,7.18a15.63,15.63,0,0,0,5.88-17.11c-.82-2.61-3.16-4.64-2.82-7.5a22.93,22.93,0,0,1,1.53-4.64C248.45,130.46,243.4,121.52,237.31,114.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,132.7a6.17,6.17,0,0,1,.22,1.83c-.07,1.66-.56,3.27-.75,4.91-.57,5.17.74,7.15.18,14-1.25,15.31-7.57,20.83-11.92,22.66-2.71,1.15-9.27,2.13-16,0l-2.28,7.83s12.94,12,.82,15.48c-7.91,2.27-14.44-.33-20.65-4.38a29.43,29.43,0,0,1-9.41-10.27l7.51-28s-4.47,3.69-10-2.23c-3.77-4-3.28-13,1.29-16.19s11.28-2.18,11.91,4.63c.26,2.86,3.32,2.52,4.51,0,1-2.09.86-4.35,2.53-6.2.69-.76,1.66-1.2,2.38-1.95,2.32-2.43,3.11-6.31,3.51-9.56.19-1.46.31-3,1.31-4.11a5.47,5.47,0,0,1,1.81-1.15c5.6-2.5,12-2.78,18-2a18.3,18.3,0,0,1,4.35,1,14.39,14.39,0,0,1,5,3.49,21.53,21.53,0,0,1,4.86,7.88C237.43,131.17,237.74,131.93,238,132.7Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.16,135.52l5.93-4.28a4,4,0,0,1-.9,5.37A3.51,3.51,0,0,1,203.16,135.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.37,130.3l5.92,4.15a3.39,3.39,0,0,1-4.9,1.14A4,4,0,0,1,229.37,130.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.83 136.47 219.82 154.06 229.17 150.96 218.83 136.47",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,172.26c3.69,3.66,9.61,6.53,13.23,7.79l1.13-3.93c-9.9-2.87-17.45-9.05-19.3-15.69A15.74,15.74,0,0,0,195.29,172.26Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.18,143.38c-.61,1.34-1.72.18-3-.4s-2.25-.37-1.65-1.71a2.6,2.6,0,0,1,3.42-1.37A2.63,2.63,0,0,1,232.18,143.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,142.41c.61,1.34-.68,1.13-2,1.71s-2.08,1.72-2.69.39a2.56,2.56,0,1,1,4.66-2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25,164.19a1.33,1.33,0,0,1-1.29.61,3.54,3.54,0,0,1-2.05-1,6,6,0,0,0-1.93-1.28,5.35,5.35,0,0,0-1.83-.11,4.83,4.83,0,0,1-1.82-.12,1.7,1.7,0,0,1-1.21-1.26,2.56,2.56,0,0,1,1.08-2.12,6.53,6.53,0,0,1,6.63-.7,4.57,4.57,0,0,1,1.81,1.42,4.76,4.76,0,0,1,.85,2.08A4,4,0,0,1,219.25,164.19Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.11,160.73a1.68,1.68,0,0,0,1.23,1.83c1.21.51,2.66,0,3.51.25a13.46,13.46,0,0,1,2.67,1.44l-.37-1.76-4.59-2.21Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.52,164.25a5.62,5.62,0,0,0-5-5.33,5.69,5.69,0,0,0-1.37,0,2.5,2.5,0,0,0-1,2.08,1.7,1.7,0,0,0,1.21,1.26,4.83,4.83,0,0,0,1.82.12,5.35,5.35,0,0,1,1.83.11,6,6,0,0,1,1.93,1.28A7.47,7.47,0,0,0,216.52,164.25Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Hand--inject-63",
    d: "M197.11,105a13.93,13.93,0,0,0-2.27,2.51c-.76,1-1.51,2-2.27,3a1.3,1.3,0,0,0-.38.87c.05.42.47.69.86.84a7,7,0,0,0,5.39-.31c2.07-1,3.73-2.7,5.92-3.4,2.48-.79,5.41-.47,8-.56,1.63-.06,3.27,0,4.91-.1,7.56-.43,11.34.38,11.34.38a27.41,27.41,0,0,1,8.71,6.06s-2.65-3.45-6.07-7c-1.75-1.81-3.59-3.46-6.25-3.34a5.33,5.33,0,0,1-3.49-1,5.4,5.4,0,0,0-2.86-1.24c-.69,0-1.36.28-2,.26-1.32,0-2.38-1.19-3.7-1.34-1.14-.13-2.23.52-3.38.63s-2.57-.45-3.87-.35a7,7,0,0,0-2,.52,33.1,33.1,0,0,0-5,2.63,12.18,12.18,0,0,0-1.44.93Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.27,225.27c-7.58,3-21.05-.51-27.39-3.81-14.11-7.36-19.73-19.9-15.64-30.13,5.24-13.09,19.22-11.39,19.22-11.39Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,179.89c-.64,20.65-1,31.68,13.16,40V202.21l-3.68-8.94-7-13.33A16.2,16.2,0,0,0,163,179.89Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.35,106.26a1,1,0,0,0-.34-.11l-.13,0-5.29-.69a2.37,2.37,0,0,1-.74-.19,4.12,4.12,0,0,1-.6-.43,5.62,5.62,0,0,0-4.26-.74l-2.54.29-.9.11s-2.79-.54-3.15-.52a10,10,0,0,0-3.45.77l-2.63,1s-.86-.35-1.19-.52c-1.06-.54-1.53-.26-2.63.14a41.94,41.94,0,0,0-4.33,2.45,10.66,10.66,0,0,0-2,1.51,10.29,10.29,0,0,0-1.73,2.82c-2,4.2-3.64,8.53-5.32,12.86-.43,1.13-.87,2.27-1.23,3.43a34.75,34.75,0,0,0-1.11,10.94c.05,3.94.05,7.88,0,11.83-.07,7.88-.25,15.77-.33,23.65s-.09,15.63.21,23.43a38.78,38.78,0,0,0,.64,6.63c1.26,6,5.16,11.23,9.78,15.31,3.19,2.83,8.44,6.92,13.13,5.05,5.13-2.05,7.34-11.21,8.27-16a54,54,0,0,0-.15-18.93c-2.07-12.64-6.75-27-9.2-39.49-1.41-7.14-2.88-11.45-1.2-14.08,1.2-1.91,3.16-4,3.91-6.16,1.19-3.39,1.18-7.08,1.91-10.6,1.12-5.43,3.86-7.21,8.3-9.69a7.36,7.36,0,0,1,1.34-.61,10.1,10.1,0,0,1,1.91-.26,14.07,14.07,0,0,0,3.21-.65,3.32,3.32,0,0,0,1.91-1.24A1,1,0,0,0,209.35,106.26Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.32,105.74c-2.25,1.41-4.61,2.49-6.51,4.37l-2,1.78a12.72,12.72,0,0,1,8.49-6.15Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.19,111.78c2.08-1.85,4.09-4,6.79-4.9s5.39-2,8.18-1.52c-2.77.1-5.34,1.29-7.92,2.21s-4.67,2.85-7.05,4.21Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.55,104.48a47.45,47.45,0,0,0-6,3c-1.78,1.36-3.54,2.85-5.4,4.13,3.05-3.38,6.68-6.73,11.42-7.11Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.19,150.84c-1.41-7.14-2.88-11.45-1.2-14.08,1.2-1.91,3.16-4,3.91-6.16a21.09,21.09,0,0,0,.61-2.2c-.78,2.43-3.19,5.14-6.2,6.92-3.33,2-2.19,2.94-.93,8.77,2.57,11.84,15.9,49.95,12.42,68.53.31-1.23.55-2.39.74-3.36a54,54,0,0,0-.15-18.93C195.32,177.69,190.64,163.3,188.19,150.84Z",
    style: {
      fill: "#f0997a"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Lines--inject-63",
    d: "M210.07,55.21a3.71,3.71,0,0,0-2.89-1.86,21.34,21.34,0,0,0-4.52-.19,36.81,36.81,0,0,0-5,.52A42.6,42.6,0,0,0,188,56.59a57,57,0,0,0-16.18,11,63.15,63.15,0,0,0-6.66,7.12,28.79,28.79,0,0,0-1.83,2.64,9.37,9.37,0,0,1-1.46-.61,2.87,2.87,0,0,1-1.67-3.38,10.83,10.83,0,0,1,1.54-3.68A22.63,22.63,0,0,1,167.31,64a55.37,55.37,0,0,1,7.12-4.59,56.47,56.47,0,0,1,23.86-6.81c.43,0,.12-.69-.23-.67a56.9,56.9,0,0,0-27.86,8.76,40.07,40.07,0,0,0-7.27,5.68A16.17,16.17,0,0,0,160.19,70a9,9,0,0,0-1.27,4.24c0,2.18,1.93,3.31,3.9,3.94a15.67,15.67,0,0,0-1.73,4.69c-.27,1.49-.11,2.76,1.41,3.41a16.31,16.31,0,0,0,4.93,1.08,29,29,0,0,0,6-.17,11,11,0,0,0,4.91,1.62,26,26,0,0,0,2.79.12,5.18,5.18,0,0,0,1.92,4.44,8.67,8.67,0,0,0,5.7,1.51,3.84,3.84,0,0,0,2.23,2.3,3.38,3.38,0,0,0,3.53-.92,3.75,3.75,0,0,0,.51.61c1.43,1.32,3.4.92,5.12.65.32,0,.06-.61-.22-.57-1.29.2-3.06.38-4.16-.48a2.16,2.16,0,0,1-.71-1,2.77,2.77,0,0,0,.26-1.89c-.08-.39-.6-.64-.88-.29a2.11,2.11,0,0,0-.37,1.93,2.85,2.85,0,0,1-1.27,1.08,2.32,2.32,0,0,1-2.93-1,4,4,0,0,1-.25-.51c.4-.06.8-.12,1.18-.21A7.16,7.16,0,0,0,194,93c.71-.65,1.85-2.08,1.18-3.08s-2.27-.84-3.24-.59a4.78,4.78,0,0,0-2.89,2,3.86,3.86,0,0,0-.49,2.65,7.31,7.31,0,0,1-5.13-1.37,4.31,4.31,0,0,1-1.38-3.78,27.77,27.77,0,0,0,5.45-.71A27.48,27.48,0,0,0,196,84.57c2-1.28,5.52-3.58,4.35-6.42a3,3,0,0,0-1.07-1.31,24.46,24.46,0,0,0,2.14-2.18c.92-1.07,1.91-2.38,1.29-3.85a4,4,0,0,0-3.28-2.16,8.71,8.71,0,0,0-1-.05c1.41-.91,2.8-1.86,4.14-2.86A24.2,24.2,0,0,0,209,59.37C209.7,58.21,210.66,56.61,210.07,55.21ZM192.72,90.07c.51-.08,1.7-.24,1.73.48a2.91,2.91,0,0,1-.9,1.59,6,6,0,0,1-2.87,1.58,11.35,11.35,0,0,1-1.24.24A3.78,3.78,0,0,1,192.72,90.07Zm-25.78-3.73a16.32,16.32,0,0,1-2.2-.38,6.39,6.39,0,0,1-2.16-.71c-.68-.48-.53-1.35-.4-2.06a15,15,0,0,1,.55-2.07,16.23,16.23,0,0,1,1.21-2.65c.47.11.93.2,1.35.27a26,26,0,0,0,8.62-.1l-.28.23c-1.93,1.8-3.4,4.53-1.6,6.95a4,4,0,0,0,.43.48A25.47,25.47,0,0,1,166.94,86.34Zm10.17,1.34a10,10,0,0,1-2.19-.72c.92-.15,1.84-.33,2.75-.53,1.47-.32,3-.68,4.43-1.08-.13.28-.26.56-.37.85a8.33,8.33,0,0,0-.49,1.84A19,19,0,0,1,177.11,87.68ZM199.37,80a8.12,8.12,0,0,1-2.92,3A26.14,26.14,0,0,1,185,87.7c-.93.15-1.89.25-2.85.31a9.63,9.63,0,0,1,.89-2.5l.31-.53a48.17,48.17,0,0,0,11.38-4.79,28.82,28.82,0,0,0,3.89-2.8A2.08,2.08,0,0,1,199.37,80Zm-15.13,3.66a17.93,17.93,0,0,1,4.07-3.9,15.79,15.79,0,0,1,7.08-3,6.44,6.44,0,0,1,2.14.11,30.77,30.77,0,0,1-5.68,3.7A50.86,50.86,0,0,1,184.24,83.69Zm16.25-13.82a2.22,2.22,0,0,1,1.26,1.42,2.48,2.48,0,0,1-.69,2.06,20.87,20.87,0,0,1-2.73,2.91l-.07.06a7.65,7.65,0,0,0-3.59-.28,19,19,0,0,0-11.9,8.09c-2.19.64-4.4,1.17-6.6,1.6-.84.17-1.68.31-2.53.43A3.51,3.51,0,0,1,172.31,84c-.4-2.43,1.88-4.37,3.72-5.78a64.93,64.93,0,0,0,9.05-2.87,75.32,75.32,0,0,0,11.55-5.66A7.2,7.2,0,0,1,200.49,69.87Zm-22.26,6.74a40.17,40.17,0,0,1,5.73-3.3,41,41,0,0,1,7.9-2.78c.6-.14,1.19-.26,1.79-.37-2,1.11-4.06,2.16-6.17,3.08A71.69,71.69,0,0,1,178.23,76.61Zm30-18.16a20.94,20.94,0,0,1-5.6,5.89,69,69,0,0,1-6.54,4.44L194.7,69a41.38,41.38,0,0,0-13.45,4.55,39.33,39.33,0,0,0-5.75,3.74,35.56,35.56,0,0,1-5,.74,21.31,21.31,0,0,1-6.09-.37,31.25,31.25,0,0,1,2.65-3.58,70.49,70.49,0,0,1,6-6.21c8.61-8,19.69-14.07,31.71-13.74a7,7,0,0,1,3.6.65C209.76,55.65,208.82,57.38,208.2,58.45Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.38,374.79l-2.08-1.11,1.9-.45A1.43,1.43,0,0,1,182.38,374.79Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,374.79l-2.08-1.11,1.9-.45A1.43,1.43,0,0,1,182.38,374.79Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24,402.56a4.66,4.66,0,0,0,4.24,0L179,375.12l-71.14-40.4-1.66-1L58.68,360.53a1.29,1.29,0,0,0,0,2.44Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.09,351.4l16.57,9.54,10.73-6.2L184.86,362v8.33c0,1.09-1.22,2.64-1.66,2.39a12.46,12.46,0,0,0-2.39.84,18,18,0,0,0-3.44,2.55l-38.08-21.31Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.09,351.4l16.57,9.54,10.73-6.2L184.86,362v8.33c0,1.09-1.22,2.64-1.66,2.39a12.46,12.46,0,0,0-2.39.84,18,18,0,0,0-3.44,2.55l-38.08-21.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,363v9l.14-.09a4.34,4.34,0,0,1,2-.63,2.14,2.14,0,0,1,1.34.31V360.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.69,375.1a2.71,2.71,0,0,1,.59-1.54,4.64,4.64,0,0,1,.59-.67,1.8,1.8,0,0,1,.2-.19l.26-.22.22-.17A4.76,4.76,0,0,1,178,372v-9l-2.32,1.34V375.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.86,370.28c0,1.09-1.22,2.64-1.66,2.39h0l-1.67-1.09v-6.87l1.67-2.87.91-.32.75.43Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.36,391.05v10.31a2.8,2.8,0,0,0,1.41-.33l5.21-3,39.71-22.92V364.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.87,352.3v7.79a3.13,3.13,0,0,0,1.41,2.45L122.74,398l5.21,3a2.8,2.8,0,0,0,1.41.33v-9.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.86,321.31,179,362.39v.95c0,.53.74.73,1.65.2s1.66-1.19,1.66-2.11l.09-.9-72.48-41.84-.29-.17a.88.88,0,0,0-.12.44v.44C109.51,319.93,108.77,320.78,107.86,321.31Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.86,321.31,179,362.39v.95c0,.53.74.73,1.65.2s1.66-1.19,1.66-2.11l.09-.9-72.48-41.84-.29-.17a.88.88,0,0,0-.12.44v.44C109.51,319.93,108.77,320.78,107.86,321.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,389.83,177.94,363c.59-.31,1.13-.56,1.36-.44l-.3-.17-71.14-41.08-.83-.48a2.69,2.69,0,0,0-2.24.34L58.68,347.79a1.29,1.29,0,0,0,0,2.44l68.56,39.6A4.72,4.72,0,0,0,131.48,389.83Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,318.52l.29.17,72.48,41.84a.62.62,0,0,1,.16-.2l.24-.13.52-.3.65-.38a.66.66,0,0,1,.82.07.2.2,0,0,1,.08.08,1.46,1.46,0,0,1,.22.3,2.22,2.22,0,0,1,.19.41c.05.14.1.31.14.47s.08.36.11.55,0,.22,0,.34a2.28,2.28,0,0,1,0,.27q0,.3,0,.63v-2a4.31,4.31,0,0,0-2.12-3.25l-68.57-39.6a4.28,4.28,0,0,0-3.77-.27l-.86.51,0,0c-.05,0-.2.12-.36.21h0A.62.62,0,0,0,109.63,318.52Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,402.56l2.86-1.66,43-24.84a2.7,2.7,0,0,1,.58-1.54,6.14,6.14,0,0,1,1.89-1.65,4.16,4.16,0,0,1,2-.64,2.13,2.13,0,0,1,1.34.44,7.4,7.4,0,0,0,.79-3.56h1.63c0,2.25-.74,4.5-1.65,5l-.83.48c-.46.27-.83.28-.83,0v-.44c0-.49-.74-.46-1.66.06s-1.65,1.36-1.65,1.85v.44c0,.25-.64.81-1.41,1.26l-41.61,24-4.5,2.6h0a4.41,4.41,0,0,1-2.11.5v-1.89A4.34,4.34,0,0,0,131.48,402.56Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,402.56l2.86-1.66,43-24.84a2.7,2.7,0,0,1,.58-1.54,6.14,6.14,0,0,1,1.89-1.65,4.16,4.16,0,0,1,2-.64,2.13,2.13,0,0,1,1.34.44,7.4,7.4,0,0,0,.79-3.56h1.63c0,2.25-.74,4.5-1.65,5l-.83.48c-.46.27-.83.28-.83,0v-.44c0-.49-.74-.46-1.66.06s-1.65,1.36-1.65,1.85v.44c0,.25-.64.81-1.41,1.26l-41.61,24-4.5,2.6h0a4.41,4.41,0,0,1-2.11.5v-1.89A4.34,4.34,0,0,0,131.48,402.56Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46,389.83h0l2.86-1.67,33.06-19.07L178,363c.74-.44,1.36-.6,1.4-.37v.51c0,.53.75.53,1.66,0a2.21,2.21,0,0,0,1.3-1.66V361a.78.78,0,0,1,.25-.62l.24-.13.52-.3.65-.38a.66.66,0,0,1,.82.07.2.2,0,0,1,.08.08.7.7,0,0,1,.15.19l.07.11a2.22,2.22,0,0,1,.19.41c.05.14.1.31.14.47s.08.36.11.55,0,.22,0,.34a2.28,2.28,0,0,1,0,.27q0,.3,0,.63v6.47H184v-6.47c0-.17,0-.34,0-.5l0-.41s0,0,0,0a4.65,4.65,0,0,1-2.46,3.06,4,4,0,0,1-2,.62,2.15,2.15,0,0,1-1.46-.54l-.15.08-.28.17-41.61,24-4.5,2.6a0,0,0,0,0,0,0h0a4.4,4.4,0,0,1-2.08.48v-1.88A4.26,4.26,0,0,0,131.46,389.83Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46,389.83h0l2.86-1.67,33.06-19.07L178,363c.74-.44,1.36-.6,1.4-.37v.51c0,.53.75.53,1.66,0a2.21,2.21,0,0,0,1.3-1.66V361a.78.78,0,0,1,.25-.62l.24-.13.52-.3.65-.38a.66.66,0,0,1,.82.07.2.2,0,0,1,.08.08.7.7,0,0,1,.15.19l.07.11a2.22,2.22,0,0,1,.19.41c.05.14.1.31.14.47s.08.36.11.55,0,.22,0,.34a2.28,2.28,0,0,1,0,.27q0,.3,0,.63v6.47H184v-6.47c0-.17,0-.34,0-.5l0-.41s0,0,0,0a4.65,4.65,0,0,1-2.46,3.06,4,4,0,0,1-2,.62,2.15,2.15,0,0,1-1.46-.54l-.15.08-.28.17-41.61,24-4.5,2.6a0,0,0,0,0,0,0h0a4.4,4.4,0,0,1-2.08.48v-1.88A4.26,4.26,0,0,0,131.46,389.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,349v1.91a1.46,1.46,0,0,0,.84,1.21h0l64.06,37,4.5,2.6h0s0,0,0,0a4.5,4.5,0,0,0,2.11.49v-1.88a4.31,4.31,0,0,1-2.12-.5l-2.86-1.66h0L58.68,350.23A1.44,1.44,0,0,1,57.81,349Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,349v1.91a1.46,1.46,0,0,0,.84,1.21h0l64.06,37,4.5,2.6h0s0,0,0,0a4.5,4.5,0,0,0,2.11.49v-1.88a4.31,4.31,0,0,1-2.12-.5l-2.86-1.66h0L58.68,350.23A1.44,1.44,0,0,1,57.81,349Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,361.72v1.92a1.43,1.43,0,0,0,.84,1.2l0,0,64.06,37,4.5,2.6h0a4.39,4.39,0,0,0,2.11.5v-1.89a4.31,4.31,0,0,1-2.12-.5l-2.86-1.65h0L58.68,363A1.45,1.45,0,0,1,57.81,361.72Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,361.72v1.92a1.43,1.43,0,0,0,.84,1.2l0,0,64.06,37,4.5,2.6h0a4.39,4.39,0,0,0,2.11.5v-1.89a4.31,4.31,0,0,1-2.12-.5l-2.86-1.65h0L58.68,363A1.45,1.45,0,0,1,57.81,361.72Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "182.4 353.93 126.84 385.58 52.95 343.18 108.5 311.52 182.4 353.93",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.4 353.93 126.84 385.58 52.95 343.18 108.5 311.52 182.4 353.93",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.33,383.64l54-30.91c-1.13-3.2-1-6.93.23-11.19l-53.7,30.65S126,374.89,126.33,383.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,368.7a9.08,9.08,0,0,0-4.14,7.13v8.34c0,2.63,1.85,3.69,4.14,2.38L182.4,356v-2.07L129.61,384c-1.37.79-2.48.15-2.48-1.43l0-7.73a5.45,5.45,0,0,1,2.49-4.28l52.74-30.09v-2.34Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,368.7a9.08,9.08,0,0,0-4.14,7.13v8.34c0,2.63,1.85,3.69,4.14,2.38L182.4,356v-2.07L129.61,384c-1.37.79-2.48.15-2.48-1.43l0-7.73a5.45,5.45,0,0,1,2.49-4.28l52.74-30.09v-2.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,338.15l-73.9-42.41L55.15,326.29A9.1,9.1,0,0,0,51,333.43v8.34a2.88,2.88,0,0,0,1.21,2.66l73.89,42.41a2.89,2.89,0,0,1-1.21-2.66v-8.35a9.11,9.11,0,0,1,4.15-7.14Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,338.15l-73.9-42.41L55.15,326.29A9.1,9.1,0,0,0,51,333.43v8.34a2.88,2.88,0,0,0,1.21,2.66l73.89,42.41a2.89,2.89,0,0,1-1.21-2.66v-8.35a9.11,9.11,0,0,1,4.15-7.14Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,371.77a8.4,8.4,0,0,0-1.22,4.06v8.35a2.89,2.89,0,0,0,1.21,2.66L52.22,344.43A2.88,2.88,0,0,1,51,341.77v-8.34a8.38,8.38,0,0,1,1.21-4.06Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,371.77a8.4,8.4,0,0,0-1.22,4.06v8.35a2.89,2.89,0,0,0,1.21,2.66L52.22,344.43A2.88,2.88,0,0,1,51,341.77v-8.34a8.38,8.38,0,0,1,1.21-4.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,334.9c-1.34,5.84-1.32,10.88,0,15.16l3.43,2c-1.32-4.28-1.34-9.32,0-15.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,363.24c-1.34,5.83-1.32,10.87,0,15.15l3.43,2c-1.32-4.29-1.34-9.33,0-15.16Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187.46,337.26v1.65a4.7,4.7,0,0,1-2.32,4.07l-44.5,25.86a4.76,4.76,0,0,1-2.34.64,4.62,4.62,0,0,1-2.33-.62L53.93,322a4.69,4.69,0,0,1-2.36-4v-1.14l86.73,49.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.57,316.79,100,288.57a2.78,2.78,0,0,1,2.79,0l84.39,48.24a.62.62,0,0,1,0,1.07l-48.85,28.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.73 362.24 164.84 347.04 88.11 303.19 61.87 318.32 138.73 362.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.41 320.2 150.93 320.48 138.13 327.94 115.26 314.87 114.79 314.6 128.06 306.86 151.41 320.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.93 320.48 138.13 327.94 115.26 314.87 128.06 307.41 150.93 320.48",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.3,366.36v3.12a4.62,4.62,0,0,1-2.33-.62L53.93,322a4.69,4.69,0,0,1-2.36-4v-1.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137,367.06a5.53,5.53,0,0,1-4.77-.35L50.53,320a5.59,5.59,0,0,1-2.72-3.87L38.66,263a7,7,0,0,1-.08-.91,5.61,5.61,0,0,1,1.62-4l84.89,48.53a4.1,4.1,0,0,1,2,2.85Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,367.06a5.53,5.53,0,0,1-4.77-.35L50.53,320a5.59,5.59,0,0,1-2.72-3.87L38.66,263a7,7,0,0,1-.08-.91,5.61,5.61,0,0,1,1.62-4l84.89,48.53a4.1,4.1,0,0,1,2,2.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,366.37l-.56.32a6,6,0,0,1-.76.37l-9.89-57.53a4.1,4.1,0,0,0-2-2.85L40.2,258.15a5.71,5.71,0,0,1,1.13-.86l85.06,48.61a4.12,4.12,0,0,1,2,2.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.93,319.89c-.61-3.56-4.31-8.27-8.26-10.53s-6.65-1.2-6,2.36S85,320,88.89,322.25,95.55,323.45,94.93,319.89Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bolts--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bolts--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "83.35 272.66 86.75 250.6 77.58 239.19 84.23 206.43 106.75 207.06 91.72 237.81 96.92 249.38 83.35 272.66",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.18 271.02 111.95 245.23 121.59 253.53 90.18 271.02",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.93 269.05 77.95 250.53 68.98 237.81 66.05 215.72 51.2 213.89 60.42 239.81 74.35 252.31 79.93 269.05",
    style: {
      fill: "#1B4ED8"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohen);
export default __webpack_public_path__ + "static/media/cohen.ae90810d0f62650f014adab422c89155.svg";
export { ForwardRef as ReactComponent };